/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicCspLocatorImport } from './routes/public-csp-locator'
import { Route as DashboardImport } from './routes/dashboard'
import { Route as IndexImport } from './routes/index'
import { Route as DashboardIndexImport } from './routes/dashboard/index'
import { Route as Ntimev1SplatImport } from './routes/ntimev1.$'
import { Route as DashboardNetworkImport } from './routes/dashboard/network'
import { Route as DashboardHomeImport } from './routes/dashboard/home'
import { Route as DashboardFieldsImport } from './routes/dashboard/fields'
import { Route as DashboardEnrollmentImport } from './routes/dashboard/enrollment'
import { Route as DashboardAddFieldImport } from './routes/dashboard/add-field'
import { Route as DashboardAccountSettingsImport } from './routes/dashboard/account-settings'
import { Route as authRegisterImport } from './routes/(auth)/register'
import { Route as authCspLocatorMapImport } from './routes/(auth)/csp-locator-map'
import { Route as authAuthImport } from './routes/(auth)/auth'
import { Route as DashboardNetworkIndexImport } from './routes/dashboard/network/index'
import { Route as DashboardHomeIndexImport } from './routes/dashboard/home/index'
import { Route as DashboardFieldsIndexImport } from './routes/dashboard/fields/index'
import { Route as DashboardEnrollmentIndexImport } from './routes/dashboard/enrollment/index'
import { Route as DashboardDocumentationIndexImport } from './routes/dashboard/documentation/index'
import { Route as DashboardAccountSettingsIndexImport } from './routes/dashboard/account-settings/index'
import { Route as authRegisterIndexImport } from './routes/(auth)/register.index'
import { Route as DashboardNetworkUsersImport } from './routes/dashboard/network/users'
import { Route as DashboardNetworkOrganizationsImport } from './routes/dashboard/network/organizations'
import { Route as DashboardNetworkSplatImport } from './routes/dashboard/network/$'
import { Route as DashboardHomeSyncedOperationsImport } from './routes/dashboard/home/synced-operations'
import { Route as DashboardHomeInsightsImport } from './routes/dashboard/home/insights'
import { Route as DashboardHomeImageryQaqcImport } from './routes/dashboard/home/imagery-qaqc'
import { Route as DashboardHomeFieldConfigImport } from './routes/dashboard/home/field-config'
import { Route as DashboardHomeDashboardImport } from './routes/dashboard/home/dashboard'
import { Route as DashboardHomeBulkRxImport } from './routes/dashboard/home/bulk-rx'
import { Route as DashboardFieldsAddBulkImport } from './routes/dashboard/fields/add-bulk'
import { Route as DashboardFieldsAddImport } from './routes/dashboard/fields/add'
import { Route as DashboardFieldsFieldIdImport } from './routes/dashboard/fields/$fieldId'
import { Route as DashboardEnrollmentFieldsImport } from './routes/dashboard/enrollment/fields'
import { Route as DashboardEnrollmentContractsImport } from './routes/dashboard/enrollment/contracts'
import { Route as DashboardAllNSplatImport } from './routes/dashboard/all-n/$'
import { Route as DashboardAccountSettingsProductsImport } from './routes/dashboard/account-settings/products'
import { Route as DashboardAccountSettingsNotificationsImport } from './routes/dashboard/account-settings/notifications'
import { Route as DashboardAccountSettingsConnectionsImport } from './routes/dashboard/account-settings/connections'
import { Route as DashboardAccountSettingsAccountImport } from './routes/dashboard/account-settings/account'
import { Route as authRegisterSelectCspImport } from './routes/(auth)/register.select-csp'
import { Route as authRegisterCspSlugImport } from './routes/(auth)/register.$cspSlug'
import { Route as authAuthRedirectPlatformImport } from './routes/(auth)/auth-redirect.$platform'
import { Route as authPasswordResetIndexImport } from './routes/(auth)/password/reset.index'
import { Route as DashboardNetworkUsersNewImport } from './routes/dashboard/network/users/new'
import { Route as DashboardNetworkUsersUserIdImport } from './routes/dashboard/network/users/$userId'
import { Route as DashboardNetworkOrganizationsNewImport } from './routes/dashboard/network/organizations/new'
import { Route as DashboardNetworkOrganizationsOrganizationIdImport } from './routes/dashboard/network/organizations/$organizationId'
import { Route as DashboardFieldsAddImportImport } from './routes/dashboard/fields/add/import'
import { Route as DashboardFieldsAddDrawImport } from './routes/dashboard/fields/add/draw'
import { Route as DashboardFieldsFieldIdSetupImport } from './routes/dashboard/fields/$fieldId/setup'
import { Route as DashboardFieldsFieldIdRxImport } from './routes/dashboard/fields/$fieldId/rx'
import { Route as DashboardFieldsFieldIdOperationsImport } from './routes/dashboard/fields/$fieldId/operations'
import { Route as DashboardFieldsFieldIdInsightsImport } from './routes/dashboard/fields/$fieldId/insights'
import { Route as DashboardFieldFieldIdSplatImport } from './routes/dashboard/field/$fieldId.$'
import { Route as authRegisterPartnerSplatImport } from './routes/(auth)/register.partner.$'
import { Route as DashboardFieldsFieldIdSetupIndexImport } from './routes/dashboard/fields/$fieldId/setup/index'
import { Route as DashboardFieldsFieldIdRxIndexImport } from './routes/dashboard/fields/$fieldId/rx/index'
import { Route as DashboardFieldsFieldIdOperationsIndexImport } from './routes/dashboard/fields/$fieldId/operations/index'
import { Route as authPasswordResetConfirmIndexImport } from './routes/(auth)/password/reset.confirm.index'
import { Route as DashboardFieldsFieldIdSetupTreatmentSectorsImport } from './routes/dashboard/fields/$fieldId/setup.treatment-sectors'
import { Route as DashboardFieldsFieldIdSetupSoilManagementImport } from './routes/dashboard/fields/$fieldId/setup.soil-management'
import { Route as DashboardFieldsFieldIdSetupManagementZonesImport } from './routes/dashboard/fields/$fieldId/setup.management-zones'
import { Route as DashboardFieldsFieldIdSetupIrrigationSystemImport } from './routes/dashboard/fields/$fieldId/setup.irrigation-system'
import { Route as DashboardFieldsFieldIdSetupFieldImport } from './routes/dashboard/fields/$fieldId/setup.field'
import { Route as DashboardFieldsFieldIdSetupFertilizerPreferencesImport } from './routes/dashboard/fields/$fieldId/setup.fertilizer-preferences'
import { Route as DashboardFieldsFieldIdSetupChemigationSystemsImport } from './routes/dashboard/fields/$fieldId/setup.chemigation-systems'
import { Route as DashboardFieldsFieldIdRxNewImport } from './routes/dashboard/fields/$fieldId/rx/new'
import { Route as DashboardFieldsFieldIdRxRxIdImport } from './routes/dashboard/fields/$fieldId/rx/$rxId'
import { Route as DashboardFieldsFieldIdOperationsAddImport } from './routes/dashboard/fields/$fieldId/operations/add'
import { Route as DashboardFieldsFieldIdInsightsWeatherImport } from './routes/dashboard/fields/$fieldId/insights.weather'
import { Route as DashboardFieldsFieldIdInsightsSettingsImport } from './routes/dashboard/fields/$fieldId/insights/settings'
import { Route as DashboardFieldsFieldIdInsightsSamplesImport } from './routes/dashboard/fields/$fieldId/insights.samples'
import { Route as DashboardFieldsFieldIdInsightsNtimeImport } from './routes/dashboard/fields/$fieldId/insights.ntime'
import { Route as DashboardFieldsFieldIdInsightsHydroflowImport } from './routes/dashboard/fields/$fieldId/insights.hydroflow'
import { Route as DashboardFieldsFieldIdInsightsDevelopmentImport } from './routes/dashboard/fields/$fieldId/insights.development'
import { Route as DashboardFieldsFieldIdRxRxIdIndexImport } from './routes/dashboard/fields/$fieldId/rx/$rxId/index'
import { Route as DashboardFieldsFieldIdInsightsHydroflowIndexImport } from './routes/dashboard/fields/$fieldId/insights.hydroflow.index'
import { Route as DashboardFieldsFieldIdOperationsPlantingPlantingOperationIdImport } from './routes/dashboard/fields/$fieldId/operations/planting.$plantingOperationId'
import { Route as DashboardFieldsFieldIdOperationsIrrigationIrrigationOperationIdImport } from './routes/dashboard/fields/$fieldId/operations/irrigation.$irrigationOperationId'
import { Route as DashboardFieldsFieldIdOperationsHarvestHarvestOperationIdImport } from './routes/dashboard/fields/$fieldId/operations/harvest.$harvestOperationId'
import { Route as DashboardFieldsFieldIdOperationsApplicationApplicationOperationIdImport } from './routes/dashboard/fields/$fieldId/operations/application.$applicationOperationId'
import { Route as DashboardFieldsFieldIdInsightsHydroflowSettingsImport } from './routes/dashboard/fields/$fieldId/insights.hydroflow.settings'
import { Route as DashboardFieldsFieldIdRxRxIdPlotsPlaceImport } from './routes/dashboard/fields/$fieldId/rx/$rxId/plots/place'
import { Route as DashboardFieldsFieldIdRxRxIdPlotsDrawImport } from './routes/dashboard/fields/$fieldId/rx/$rxId/plots/draw'
import { Route as DashboardFieldsFieldIdRxRxIdPlotsPairIdImport } from './routes/dashboard/fields/$fieldId/rx/$rxId/plots/$pairId'

// Create/Update Routes

const PublicCspLocatorRoute = PublicCspLocatorImport.update({
  id: '/public-csp-locator',
  path: '/public-csp-locator',
  getParentRoute: () => rootRoute,
} as any)

const DashboardRoute = DashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardIndexRoute = DashboardIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)

const Ntimev1SplatRoute = Ntimev1SplatImport.update({
  id: '/ntimev1/$',
  path: '/ntimev1/$',
  getParentRoute: () => rootRoute,
} as any)

const DashboardNetworkRoute = DashboardNetworkImport.update({
  id: '/network',
  path: '/network',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardHomeRoute = DashboardHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardFieldsRoute = DashboardFieldsImport.update({
  id: '/fields',
  path: '/fields',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardEnrollmentRoute = DashboardEnrollmentImport.update({
  id: '/enrollment',
  path: '/enrollment',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardAddFieldRoute = DashboardAddFieldImport.update({
  id: '/add-field',
  path: '/add-field',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardAccountSettingsRoute = DashboardAccountSettingsImport.update({
  id: '/account-settings',
  path: '/account-settings',
  getParentRoute: () => DashboardRoute,
} as any)

const authRegisterRoute = authRegisterImport.update({
  id: '/(auth)/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const authCspLocatorMapRoute = authCspLocatorMapImport.update({
  id: '/(auth)/csp-locator-map',
  path: '/csp-locator-map',
  getParentRoute: () => rootRoute,
} as any)

const authAuthRoute = authAuthImport.update({
  id: '/(auth)/auth',
  path: '/auth',
  getParentRoute: () => rootRoute,
} as any)

const DashboardNetworkIndexRoute = DashboardNetworkIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardNetworkRoute,
} as any)

const DashboardHomeIndexRoute = DashboardHomeIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardHomeRoute,
} as any)

const DashboardFieldsIndexRoute = DashboardFieldsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardFieldsRoute,
} as any)

const DashboardEnrollmentIndexRoute = DashboardEnrollmentIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardEnrollmentRoute,
} as any)

const DashboardDocumentationIndexRoute =
  DashboardDocumentationIndexImport.update({
    id: '/documentation/',
    path: '/documentation/',
    getParentRoute: () => DashboardRoute,
  } as any)

const DashboardAccountSettingsIndexRoute =
  DashboardAccountSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAccountSettingsRoute,
  } as any)

const authRegisterIndexRoute = authRegisterIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authRegisterRoute,
} as any)

const DashboardNetworkUsersRoute = DashboardNetworkUsersImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => DashboardNetworkRoute,
} as any)

const DashboardNetworkOrganizationsRoute =
  DashboardNetworkOrganizationsImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => DashboardNetworkRoute,
  } as any)

const DashboardNetworkSplatRoute = DashboardNetworkSplatImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => DashboardNetworkRoute,
} as any)

const DashboardHomeSyncedOperationsRoute =
  DashboardHomeSyncedOperationsImport.update({
    id: '/synced-operations',
    path: '/synced-operations',
    getParentRoute: () => DashboardHomeRoute,
  } as any)

const DashboardHomeInsightsRoute = DashboardHomeInsightsImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => DashboardHomeRoute,
} as any)

const DashboardHomeImageryQaqcRoute = DashboardHomeImageryQaqcImport.update({
  id: '/imagery-qaqc',
  path: '/imagery-qaqc',
  getParentRoute: () => DashboardHomeRoute,
} as any)

const DashboardHomeFieldConfigRoute = DashboardHomeFieldConfigImport.update({
  id: '/field-config',
  path: '/field-config',
  getParentRoute: () => DashboardHomeRoute,
} as any)

const DashboardHomeDashboardRoute = DashboardHomeDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => DashboardHomeRoute,
} as any)

const DashboardHomeBulkRxRoute = DashboardHomeBulkRxImport.update({
  id: '/bulk-rx',
  path: '/bulk-rx',
  getParentRoute: () => DashboardHomeRoute,
} as any)

const DashboardFieldsAddBulkRoute = DashboardFieldsAddBulkImport.update({
  id: '/add-bulk',
  path: '/add-bulk',
  getParentRoute: () => DashboardFieldsRoute,
} as any)

const DashboardFieldsAddRoute = DashboardFieldsAddImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => DashboardFieldsRoute,
} as any)

const DashboardFieldsFieldIdRoute = DashboardFieldsFieldIdImport.update({
  id: '/$fieldId',
  path: '/$fieldId',
  getParentRoute: () => DashboardFieldsRoute,
} as any)

const DashboardEnrollmentFieldsRoute = DashboardEnrollmentFieldsImport.update({
  id: '/fields',
  path: '/fields',
  getParentRoute: () => DashboardEnrollmentRoute,
} as any)

const DashboardEnrollmentContractsRoute =
  DashboardEnrollmentContractsImport.update({
    id: '/contracts',
    path: '/contracts',
    getParentRoute: () => DashboardEnrollmentRoute,
  } as any)

const DashboardAllNSplatRoute = DashboardAllNSplatImport.update({
  id: '/all-n/$',
  path: '/all-n/$',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardAccountSettingsProductsRoute =
  DashboardAccountSettingsProductsImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => DashboardAccountSettingsRoute,
  } as any)

const DashboardAccountSettingsNotificationsRoute =
  DashboardAccountSettingsNotificationsImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => DashboardAccountSettingsRoute,
  } as any)

const DashboardAccountSettingsConnectionsRoute =
  DashboardAccountSettingsConnectionsImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => DashboardAccountSettingsRoute,
  } as any)

const DashboardAccountSettingsAccountRoute =
  DashboardAccountSettingsAccountImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => DashboardAccountSettingsRoute,
  } as any)

const authRegisterSelectCspRoute = authRegisterSelectCspImport.update({
  id: '/select-csp',
  path: '/select-csp',
  getParentRoute: () => authRegisterRoute,
} as any)

const authRegisterCspSlugRoute = authRegisterCspSlugImport.update({
  id: '/$cspSlug',
  path: '/$cspSlug',
  getParentRoute: () => authRegisterRoute,
} as any)

const authAuthRedirectPlatformRoute = authAuthRedirectPlatformImport.update({
  id: '/(auth)/auth-redirect/$platform',
  path: '/auth-redirect/$platform',
  getParentRoute: () => rootRoute,
} as any)

const authPasswordResetIndexRoute = authPasswordResetIndexImport.update({
  id: '/(auth)/password/reset/',
  path: '/password/reset/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardNetworkUsersNewRoute = DashboardNetworkUsersNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => DashboardNetworkUsersRoute,
} as any)

const DashboardNetworkUsersUserIdRoute =
  DashboardNetworkUsersUserIdImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => DashboardNetworkUsersRoute,
  } as any)

const DashboardNetworkOrganizationsNewRoute =
  DashboardNetworkOrganizationsNewImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardNetworkOrganizationsRoute,
  } as any)

const DashboardNetworkOrganizationsOrganizationIdRoute =
  DashboardNetworkOrganizationsOrganizationIdImport.update({
    id: '/$organizationId',
    path: '/$organizationId',
    getParentRoute: () => DashboardNetworkOrganizationsRoute,
  } as any)

const DashboardFieldsAddImportRoute = DashboardFieldsAddImportImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => DashboardFieldsAddRoute,
} as any)

const DashboardFieldsAddDrawRoute = DashboardFieldsAddDrawImport.update({
  id: '/draw',
  path: '/draw',
  getParentRoute: () => DashboardFieldsAddRoute,
} as any)

const DashboardFieldsFieldIdSetupRoute =
  DashboardFieldsFieldIdSetupImport.update({
    id: '/setup',
    path: '/setup',
    getParentRoute: () => DashboardFieldsFieldIdRoute,
  } as any)

const DashboardFieldsFieldIdRxRoute = DashboardFieldsFieldIdRxImport.update({
  id: '/rx',
  path: '/rx',
  getParentRoute: () => DashboardFieldsFieldIdRoute,
} as any)

const DashboardFieldsFieldIdOperationsRoute =
  DashboardFieldsFieldIdOperationsImport.update({
    id: '/operations',
    path: '/operations',
    getParentRoute: () => DashboardFieldsFieldIdRoute,
  } as any)

const DashboardFieldsFieldIdInsightsRoute =
  DashboardFieldsFieldIdInsightsImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => DashboardFieldsFieldIdRoute,
  } as any)

const DashboardFieldFieldIdSplatRoute = DashboardFieldFieldIdSplatImport.update(
  {
    id: '/field/$fieldId/$',
    path: '/field/$fieldId/$',
    getParentRoute: () => DashboardRoute,
  } as any,
)

const authRegisterPartnerSplatRoute = authRegisterPartnerSplatImport.update({
  id: '/partner/$',
  path: '/partner/$',
  getParentRoute: () => authRegisterRoute,
} as any)

const DashboardFieldsFieldIdSetupIndexRoute =
  DashboardFieldsFieldIdSetupIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardFieldsFieldIdSetupRoute,
  } as any)

const DashboardFieldsFieldIdRxIndexRoute =
  DashboardFieldsFieldIdRxIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardFieldsFieldIdRxRoute,
  } as any)

const DashboardFieldsFieldIdOperationsIndexRoute =
  DashboardFieldsFieldIdOperationsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardFieldsFieldIdOperationsRoute,
  } as any)

const authPasswordResetConfirmIndexRoute =
  authPasswordResetConfirmIndexImport.update({
    id: '/(auth)/password/reset/confirm/',
    path: '/password/reset/confirm/',
    getParentRoute: () => rootRoute,
  } as any)

const DashboardFieldsFieldIdSetupTreatmentSectorsRoute =
  DashboardFieldsFieldIdSetupTreatmentSectorsImport.update({
    id: '/treatment-sectors',
    path: '/treatment-sectors',
    getParentRoute: () => DashboardFieldsFieldIdSetupRoute,
  } as any)

const DashboardFieldsFieldIdSetupSoilManagementRoute =
  DashboardFieldsFieldIdSetupSoilManagementImport.update({
    id: '/soil-management',
    path: '/soil-management',
    getParentRoute: () => DashboardFieldsFieldIdSetupRoute,
  } as any)

const DashboardFieldsFieldIdSetupManagementZonesRoute =
  DashboardFieldsFieldIdSetupManagementZonesImport.update({
    id: '/management-zones',
    path: '/management-zones',
    getParentRoute: () => DashboardFieldsFieldIdSetupRoute,
  } as any)

const DashboardFieldsFieldIdSetupIrrigationSystemRoute =
  DashboardFieldsFieldIdSetupIrrigationSystemImport.update({
    id: '/irrigation-system',
    path: '/irrigation-system',
    getParentRoute: () => DashboardFieldsFieldIdSetupRoute,
  } as any)

const DashboardFieldsFieldIdSetupFieldRoute =
  DashboardFieldsFieldIdSetupFieldImport.update({
    id: '/field',
    path: '/field',
    getParentRoute: () => DashboardFieldsFieldIdSetupRoute,
  } as any)

const DashboardFieldsFieldIdSetupFertilizerPreferencesRoute =
  DashboardFieldsFieldIdSetupFertilizerPreferencesImport.update({
    id: '/fertilizer-preferences',
    path: '/fertilizer-preferences',
    getParentRoute: () => DashboardFieldsFieldIdSetupRoute,
  } as any)

const DashboardFieldsFieldIdSetupChemigationSystemsRoute =
  DashboardFieldsFieldIdSetupChemigationSystemsImport.update({
    id: '/chemigation-systems',
    path: '/chemigation-systems',
    getParentRoute: () => DashboardFieldsFieldIdSetupRoute,
  } as any)

const DashboardFieldsFieldIdRxNewRoute =
  DashboardFieldsFieldIdRxNewImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardFieldsFieldIdRxRoute,
  } as any)

const DashboardFieldsFieldIdRxRxIdRoute =
  DashboardFieldsFieldIdRxRxIdImport.update({
    id: '/$rxId',
    path: '/$rxId',
    getParentRoute: () => DashboardFieldsFieldIdRxRoute,
  } as any)

const DashboardFieldsFieldIdOperationsAddRoute =
  DashboardFieldsFieldIdOperationsAddImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => DashboardFieldsFieldIdOperationsRoute,
  } as any)

const DashboardFieldsFieldIdInsightsWeatherRoute =
  DashboardFieldsFieldIdInsightsWeatherImport.update({
    id: '/weather',
    path: '/weather',
    getParentRoute: () => DashboardFieldsFieldIdInsightsRoute,
  } as any)

const DashboardFieldsFieldIdInsightsSettingsRoute =
  DashboardFieldsFieldIdInsightsSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => DashboardFieldsFieldIdInsightsRoute,
  } as any)

const DashboardFieldsFieldIdInsightsSamplesRoute =
  DashboardFieldsFieldIdInsightsSamplesImport.update({
    id: '/samples',
    path: '/samples',
    getParentRoute: () => DashboardFieldsFieldIdInsightsRoute,
  } as any)

const DashboardFieldsFieldIdInsightsNtimeRoute =
  DashboardFieldsFieldIdInsightsNtimeImport.update({
    id: '/ntime',
    path: '/ntime',
    getParentRoute: () => DashboardFieldsFieldIdInsightsRoute,
  } as any)

const DashboardFieldsFieldIdInsightsHydroflowRoute =
  DashboardFieldsFieldIdInsightsHydroflowImport.update({
    id: '/hydroflow',
    path: '/hydroflow',
    getParentRoute: () => DashboardFieldsFieldIdInsightsRoute,
  } as any)

const DashboardFieldsFieldIdInsightsDevelopmentRoute =
  DashboardFieldsFieldIdInsightsDevelopmentImport.update({
    id: '/development',
    path: '/development',
    getParentRoute: () => DashboardFieldsFieldIdInsightsRoute,
  } as any)

const DashboardFieldsFieldIdRxRxIdIndexRoute =
  DashboardFieldsFieldIdRxRxIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardFieldsFieldIdRxRxIdRoute,
  } as any)

const DashboardFieldsFieldIdInsightsHydroflowIndexRoute =
  DashboardFieldsFieldIdInsightsHydroflowIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardFieldsFieldIdInsightsHydroflowRoute,
  } as any)

const DashboardFieldsFieldIdOperationsPlantingPlantingOperationIdRoute =
  DashboardFieldsFieldIdOperationsPlantingPlantingOperationIdImport.update({
    id: '/planting/$plantingOperationId',
    path: '/planting/$plantingOperationId',
    getParentRoute: () => DashboardFieldsFieldIdOperationsRoute,
  } as any)

const DashboardFieldsFieldIdOperationsIrrigationIrrigationOperationIdRoute =
  DashboardFieldsFieldIdOperationsIrrigationIrrigationOperationIdImport.update({
    id: '/irrigation/$irrigationOperationId',
    path: '/irrigation/$irrigationOperationId',
    getParentRoute: () => DashboardFieldsFieldIdOperationsRoute,
  } as any)

const DashboardFieldsFieldIdOperationsHarvestHarvestOperationIdRoute =
  DashboardFieldsFieldIdOperationsHarvestHarvestOperationIdImport.update({
    id: '/harvest/$harvestOperationId',
    path: '/harvest/$harvestOperationId',
    getParentRoute: () => DashboardFieldsFieldIdOperationsRoute,
  } as any)

const DashboardFieldsFieldIdOperationsApplicationApplicationOperationIdRoute =
  DashboardFieldsFieldIdOperationsApplicationApplicationOperationIdImport.update(
    {
      id: '/application/$applicationOperationId',
      path: '/application/$applicationOperationId',
      getParentRoute: () => DashboardFieldsFieldIdOperationsRoute,
    } as any,
  )

const DashboardFieldsFieldIdInsightsHydroflowSettingsRoute =
  DashboardFieldsFieldIdInsightsHydroflowSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => DashboardFieldsFieldIdInsightsHydroflowRoute,
  } as any)

const DashboardFieldsFieldIdRxRxIdPlotsPlaceRoute =
  DashboardFieldsFieldIdRxRxIdPlotsPlaceImport.update({
    id: '/plots/place',
    path: '/plots/place',
    getParentRoute: () => DashboardFieldsFieldIdRxRxIdRoute,
  } as any)

const DashboardFieldsFieldIdRxRxIdPlotsDrawRoute =
  DashboardFieldsFieldIdRxRxIdPlotsDrawImport.update({
    id: '/plots/draw',
    path: '/plots/draw',
    getParentRoute: () => DashboardFieldsFieldIdRxRxIdRoute,
  } as any)

const DashboardFieldsFieldIdRxRxIdPlotsPairIdRoute =
  DashboardFieldsFieldIdRxRxIdPlotsPairIdImport.update({
    id: '/plots/$pairId',
    path: '/plots/$pairId',
    getParentRoute: () => DashboardFieldsFieldIdRxRxIdRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardImport
      parentRoute: typeof rootRoute
    }
    '/public-csp-locator': {
      id: '/public-csp-locator'
      path: '/public-csp-locator'
      fullPath: '/public-csp-locator'
      preLoaderRoute: typeof PublicCspLocatorImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/auth': {
      id: '/(auth)/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof authAuthImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/csp-locator-map': {
      id: '/(auth)/csp-locator-map'
      path: '/csp-locator-map'
      fullPath: '/csp-locator-map'
      preLoaderRoute: typeof authCspLocatorMapImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/register': {
      id: '/(auth)/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof authRegisterImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/account-settings': {
      id: '/dashboard/account-settings'
      path: '/account-settings'
      fullPath: '/dashboard/account-settings'
      preLoaderRoute: typeof DashboardAccountSettingsImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/add-field': {
      id: '/dashboard/add-field'
      path: '/add-field'
      fullPath: '/dashboard/add-field'
      preLoaderRoute: typeof DashboardAddFieldImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/enrollment': {
      id: '/dashboard/enrollment'
      path: '/enrollment'
      fullPath: '/dashboard/enrollment'
      preLoaderRoute: typeof DashboardEnrollmentImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/fields': {
      id: '/dashboard/fields'
      path: '/fields'
      fullPath: '/dashboard/fields'
      preLoaderRoute: typeof DashboardFieldsImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/home': {
      id: '/dashboard/home'
      path: '/home'
      fullPath: '/dashboard/home'
      preLoaderRoute: typeof DashboardHomeImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/network': {
      id: '/dashboard/network'
      path: '/network'
      fullPath: '/dashboard/network'
      preLoaderRoute: typeof DashboardNetworkImport
      parentRoute: typeof DashboardImport
    }
    '/ntimev1/$': {
      id: '/ntimev1/$'
      path: '/ntimev1/$'
      fullPath: '/ntimev1/$'
      preLoaderRoute: typeof Ntimev1SplatImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexImport
      parentRoute: typeof DashboardImport
    }
    '/(auth)/auth-redirect/$platform': {
      id: '/(auth)/auth-redirect/$platform'
      path: '/auth-redirect/$platform'
      fullPath: '/auth-redirect/$platform'
      preLoaderRoute: typeof authAuthRedirectPlatformImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/register/$cspSlug': {
      id: '/(auth)/register/$cspSlug'
      path: '/$cspSlug'
      fullPath: '/register/$cspSlug'
      preLoaderRoute: typeof authRegisterCspSlugImport
      parentRoute: typeof authRegisterImport
    }
    '/(auth)/register/select-csp': {
      id: '/(auth)/register/select-csp'
      path: '/select-csp'
      fullPath: '/register/select-csp'
      preLoaderRoute: typeof authRegisterSelectCspImport
      parentRoute: typeof authRegisterImport
    }
    '/dashboard/account-settings/account': {
      id: '/dashboard/account-settings/account'
      path: '/account'
      fullPath: '/dashboard/account-settings/account'
      preLoaderRoute: typeof DashboardAccountSettingsAccountImport
      parentRoute: typeof DashboardAccountSettingsImport
    }
    '/dashboard/account-settings/connections': {
      id: '/dashboard/account-settings/connections'
      path: '/connections'
      fullPath: '/dashboard/account-settings/connections'
      preLoaderRoute: typeof DashboardAccountSettingsConnectionsImport
      parentRoute: typeof DashboardAccountSettingsImport
    }
    '/dashboard/account-settings/notifications': {
      id: '/dashboard/account-settings/notifications'
      path: '/notifications'
      fullPath: '/dashboard/account-settings/notifications'
      preLoaderRoute: typeof DashboardAccountSettingsNotificationsImport
      parentRoute: typeof DashboardAccountSettingsImport
    }
    '/dashboard/account-settings/products': {
      id: '/dashboard/account-settings/products'
      path: '/products'
      fullPath: '/dashboard/account-settings/products'
      preLoaderRoute: typeof DashboardAccountSettingsProductsImport
      parentRoute: typeof DashboardAccountSettingsImport
    }
    '/dashboard/all-n/$': {
      id: '/dashboard/all-n/$'
      path: '/all-n/$'
      fullPath: '/dashboard/all-n/$'
      preLoaderRoute: typeof DashboardAllNSplatImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/enrollment/contracts': {
      id: '/dashboard/enrollment/contracts'
      path: '/contracts'
      fullPath: '/dashboard/enrollment/contracts'
      preLoaderRoute: typeof DashboardEnrollmentContractsImport
      parentRoute: typeof DashboardEnrollmentImport
    }
    '/dashboard/enrollment/fields': {
      id: '/dashboard/enrollment/fields'
      path: '/fields'
      fullPath: '/dashboard/enrollment/fields'
      preLoaderRoute: typeof DashboardEnrollmentFieldsImport
      parentRoute: typeof DashboardEnrollmentImport
    }
    '/dashboard/fields/$fieldId': {
      id: '/dashboard/fields/$fieldId'
      path: '/$fieldId'
      fullPath: '/dashboard/fields/$fieldId'
      preLoaderRoute: typeof DashboardFieldsFieldIdImport
      parentRoute: typeof DashboardFieldsImport
    }
    '/dashboard/fields/add': {
      id: '/dashboard/fields/add'
      path: '/add'
      fullPath: '/dashboard/fields/add'
      preLoaderRoute: typeof DashboardFieldsAddImport
      parentRoute: typeof DashboardFieldsImport
    }
    '/dashboard/fields/add-bulk': {
      id: '/dashboard/fields/add-bulk'
      path: '/add-bulk'
      fullPath: '/dashboard/fields/add-bulk'
      preLoaderRoute: typeof DashboardFieldsAddBulkImport
      parentRoute: typeof DashboardFieldsImport
    }
    '/dashboard/home/bulk-rx': {
      id: '/dashboard/home/bulk-rx'
      path: '/bulk-rx'
      fullPath: '/dashboard/home/bulk-rx'
      preLoaderRoute: typeof DashboardHomeBulkRxImport
      parentRoute: typeof DashboardHomeImport
    }
    '/dashboard/home/dashboard': {
      id: '/dashboard/home/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard/home/dashboard'
      preLoaderRoute: typeof DashboardHomeDashboardImport
      parentRoute: typeof DashboardHomeImport
    }
    '/dashboard/home/field-config': {
      id: '/dashboard/home/field-config'
      path: '/field-config'
      fullPath: '/dashboard/home/field-config'
      preLoaderRoute: typeof DashboardHomeFieldConfigImport
      parentRoute: typeof DashboardHomeImport
    }
    '/dashboard/home/imagery-qaqc': {
      id: '/dashboard/home/imagery-qaqc'
      path: '/imagery-qaqc'
      fullPath: '/dashboard/home/imagery-qaqc'
      preLoaderRoute: typeof DashboardHomeImageryQaqcImport
      parentRoute: typeof DashboardHomeImport
    }
    '/dashboard/home/insights': {
      id: '/dashboard/home/insights'
      path: '/insights'
      fullPath: '/dashboard/home/insights'
      preLoaderRoute: typeof DashboardHomeInsightsImport
      parentRoute: typeof DashboardHomeImport
    }
    '/dashboard/home/synced-operations': {
      id: '/dashboard/home/synced-operations'
      path: '/synced-operations'
      fullPath: '/dashboard/home/synced-operations'
      preLoaderRoute: typeof DashboardHomeSyncedOperationsImport
      parentRoute: typeof DashboardHomeImport
    }
    '/dashboard/network/$': {
      id: '/dashboard/network/$'
      path: '/$'
      fullPath: '/dashboard/network/$'
      preLoaderRoute: typeof DashboardNetworkSplatImport
      parentRoute: typeof DashboardNetworkImport
    }
    '/dashboard/network/organizations': {
      id: '/dashboard/network/organizations'
      path: '/organizations'
      fullPath: '/dashboard/network/organizations'
      preLoaderRoute: typeof DashboardNetworkOrganizationsImport
      parentRoute: typeof DashboardNetworkImport
    }
    '/dashboard/network/users': {
      id: '/dashboard/network/users'
      path: '/users'
      fullPath: '/dashboard/network/users'
      preLoaderRoute: typeof DashboardNetworkUsersImport
      parentRoute: typeof DashboardNetworkImport
    }
    '/(auth)/register/': {
      id: '/(auth)/register/'
      path: '/'
      fullPath: '/register/'
      preLoaderRoute: typeof authRegisterIndexImport
      parentRoute: typeof authRegisterImport
    }
    '/dashboard/account-settings/': {
      id: '/dashboard/account-settings/'
      path: '/'
      fullPath: '/dashboard/account-settings/'
      preLoaderRoute: typeof DashboardAccountSettingsIndexImport
      parentRoute: typeof DashboardAccountSettingsImport
    }
    '/dashboard/documentation/': {
      id: '/dashboard/documentation/'
      path: '/documentation'
      fullPath: '/dashboard/documentation'
      preLoaderRoute: typeof DashboardDocumentationIndexImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/enrollment/': {
      id: '/dashboard/enrollment/'
      path: '/'
      fullPath: '/dashboard/enrollment/'
      preLoaderRoute: typeof DashboardEnrollmentIndexImport
      parentRoute: typeof DashboardEnrollmentImport
    }
    '/dashboard/fields/': {
      id: '/dashboard/fields/'
      path: '/'
      fullPath: '/dashboard/fields/'
      preLoaderRoute: typeof DashboardFieldsIndexImport
      parentRoute: typeof DashboardFieldsImport
    }
    '/dashboard/home/': {
      id: '/dashboard/home/'
      path: '/'
      fullPath: '/dashboard/home/'
      preLoaderRoute: typeof DashboardHomeIndexImport
      parentRoute: typeof DashboardHomeImport
    }
    '/dashboard/network/': {
      id: '/dashboard/network/'
      path: '/'
      fullPath: '/dashboard/network/'
      preLoaderRoute: typeof DashboardNetworkIndexImport
      parentRoute: typeof DashboardNetworkImport
    }
    '/(auth)/register/partner/$': {
      id: '/(auth)/register/partner/$'
      path: '/partner/$'
      fullPath: '/register/partner/$'
      preLoaderRoute: typeof authRegisterPartnerSplatImport
      parentRoute: typeof authRegisterImport
    }
    '/dashboard/field/$fieldId/$': {
      id: '/dashboard/field/$fieldId/$'
      path: '/field/$fieldId/$'
      fullPath: '/dashboard/field/$fieldId/$'
      preLoaderRoute: typeof DashboardFieldFieldIdSplatImport
      parentRoute: typeof DashboardImport
    }
    '/dashboard/fields/$fieldId/insights': {
      id: '/dashboard/fields/$fieldId/insights'
      path: '/insights'
      fullPath: '/dashboard/fields/$fieldId/insights'
      preLoaderRoute: typeof DashboardFieldsFieldIdInsightsImport
      parentRoute: typeof DashboardFieldsFieldIdImport
    }
    '/dashboard/fields/$fieldId/operations': {
      id: '/dashboard/fields/$fieldId/operations'
      path: '/operations'
      fullPath: '/dashboard/fields/$fieldId/operations'
      preLoaderRoute: typeof DashboardFieldsFieldIdOperationsImport
      parentRoute: typeof DashboardFieldsFieldIdImport
    }
    '/dashboard/fields/$fieldId/rx': {
      id: '/dashboard/fields/$fieldId/rx'
      path: '/rx'
      fullPath: '/dashboard/fields/$fieldId/rx'
      preLoaderRoute: typeof DashboardFieldsFieldIdRxImport
      parentRoute: typeof DashboardFieldsFieldIdImport
    }
    '/dashboard/fields/$fieldId/setup': {
      id: '/dashboard/fields/$fieldId/setup'
      path: '/setup'
      fullPath: '/dashboard/fields/$fieldId/setup'
      preLoaderRoute: typeof DashboardFieldsFieldIdSetupImport
      parentRoute: typeof DashboardFieldsFieldIdImport
    }
    '/dashboard/fields/add/draw': {
      id: '/dashboard/fields/add/draw'
      path: '/draw'
      fullPath: '/dashboard/fields/add/draw'
      preLoaderRoute: typeof DashboardFieldsAddDrawImport
      parentRoute: typeof DashboardFieldsAddImport
    }
    '/dashboard/fields/add/import': {
      id: '/dashboard/fields/add/import'
      path: '/import'
      fullPath: '/dashboard/fields/add/import'
      preLoaderRoute: typeof DashboardFieldsAddImportImport
      parentRoute: typeof DashboardFieldsAddImport
    }
    '/dashboard/network/organizations/$organizationId': {
      id: '/dashboard/network/organizations/$organizationId'
      path: '/$organizationId'
      fullPath: '/dashboard/network/organizations/$organizationId'
      preLoaderRoute: typeof DashboardNetworkOrganizationsOrganizationIdImport
      parentRoute: typeof DashboardNetworkOrganizationsImport
    }
    '/dashboard/network/organizations/new': {
      id: '/dashboard/network/organizations/new'
      path: '/new'
      fullPath: '/dashboard/network/organizations/new'
      preLoaderRoute: typeof DashboardNetworkOrganizationsNewImport
      parentRoute: typeof DashboardNetworkOrganizationsImport
    }
    '/dashboard/network/users/$userId': {
      id: '/dashboard/network/users/$userId'
      path: '/$userId'
      fullPath: '/dashboard/network/users/$userId'
      preLoaderRoute: typeof DashboardNetworkUsersUserIdImport
      parentRoute: typeof DashboardNetworkUsersImport
    }
    '/dashboard/network/users/new': {
      id: '/dashboard/network/users/new'
      path: '/new'
      fullPath: '/dashboard/network/users/new'
      preLoaderRoute: typeof DashboardNetworkUsersNewImport
      parentRoute: typeof DashboardNetworkUsersImport
    }
    '/(auth)/password/reset/': {
      id: '/(auth)/password/reset/'
      path: '/password/reset'
      fullPath: '/password/reset'
      preLoaderRoute: typeof authPasswordResetIndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/fields/$fieldId/insights/development': {
      id: '/dashboard/fields/$fieldId/insights/development'
      path: '/development'
      fullPath: '/dashboard/fields/$fieldId/insights/development'
      preLoaderRoute: typeof DashboardFieldsFieldIdInsightsDevelopmentImport
      parentRoute: typeof DashboardFieldsFieldIdInsightsImport
    }
    '/dashboard/fields/$fieldId/insights/hydroflow': {
      id: '/dashboard/fields/$fieldId/insights/hydroflow'
      path: '/hydroflow'
      fullPath: '/dashboard/fields/$fieldId/insights/hydroflow'
      preLoaderRoute: typeof DashboardFieldsFieldIdInsightsHydroflowImport
      parentRoute: typeof DashboardFieldsFieldIdInsightsImport
    }
    '/dashboard/fields/$fieldId/insights/ntime': {
      id: '/dashboard/fields/$fieldId/insights/ntime'
      path: '/ntime'
      fullPath: '/dashboard/fields/$fieldId/insights/ntime'
      preLoaderRoute: typeof DashboardFieldsFieldIdInsightsNtimeImport
      parentRoute: typeof DashboardFieldsFieldIdInsightsImport
    }
    '/dashboard/fields/$fieldId/insights/samples': {
      id: '/dashboard/fields/$fieldId/insights/samples'
      path: '/samples'
      fullPath: '/dashboard/fields/$fieldId/insights/samples'
      preLoaderRoute: typeof DashboardFieldsFieldIdInsightsSamplesImport
      parentRoute: typeof DashboardFieldsFieldIdInsightsImport
    }
    '/dashboard/fields/$fieldId/insights/settings': {
      id: '/dashboard/fields/$fieldId/insights/settings'
      path: '/settings'
      fullPath: '/dashboard/fields/$fieldId/insights/settings'
      preLoaderRoute: typeof DashboardFieldsFieldIdInsightsSettingsImport
      parentRoute: typeof DashboardFieldsFieldIdInsightsImport
    }
    '/dashboard/fields/$fieldId/insights/weather': {
      id: '/dashboard/fields/$fieldId/insights/weather'
      path: '/weather'
      fullPath: '/dashboard/fields/$fieldId/insights/weather'
      preLoaderRoute: typeof DashboardFieldsFieldIdInsightsWeatherImport
      parentRoute: typeof DashboardFieldsFieldIdInsightsImport
    }
    '/dashboard/fields/$fieldId/operations/add': {
      id: '/dashboard/fields/$fieldId/operations/add'
      path: '/add'
      fullPath: '/dashboard/fields/$fieldId/operations/add'
      preLoaderRoute: typeof DashboardFieldsFieldIdOperationsAddImport
      parentRoute: typeof DashboardFieldsFieldIdOperationsImport
    }
    '/dashboard/fields/$fieldId/rx/$rxId': {
      id: '/dashboard/fields/$fieldId/rx/$rxId'
      path: '/$rxId'
      fullPath: '/dashboard/fields/$fieldId/rx/$rxId'
      preLoaderRoute: typeof DashboardFieldsFieldIdRxRxIdImport
      parentRoute: typeof DashboardFieldsFieldIdRxImport
    }
    '/dashboard/fields/$fieldId/rx/new': {
      id: '/dashboard/fields/$fieldId/rx/new'
      path: '/new'
      fullPath: '/dashboard/fields/$fieldId/rx/new'
      preLoaderRoute: typeof DashboardFieldsFieldIdRxNewImport
      parentRoute: typeof DashboardFieldsFieldIdRxImport
    }
    '/dashboard/fields/$fieldId/setup/chemigation-systems': {
      id: '/dashboard/fields/$fieldId/setup/chemigation-systems'
      path: '/chemigation-systems'
      fullPath: '/dashboard/fields/$fieldId/setup/chemigation-systems'
      preLoaderRoute: typeof DashboardFieldsFieldIdSetupChemigationSystemsImport
      parentRoute: typeof DashboardFieldsFieldIdSetupImport
    }
    '/dashboard/fields/$fieldId/setup/fertilizer-preferences': {
      id: '/dashboard/fields/$fieldId/setup/fertilizer-preferences'
      path: '/fertilizer-preferences'
      fullPath: '/dashboard/fields/$fieldId/setup/fertilizer-preferences'
      preLoaderRoute: typeof DashboardFieldsFieldIdSetupFertilizerPreferencesImport
      parentRoute: typeof DashboardFieldsFieldIdSetupImport
    }
    '/dashboard/fields/$fieldId/setup/field': {
      id: '/dashboard/fields/$fieldId/setup/field'
      path: '/field'
      fullPath: '/dashboard/fields/$fieldId/setup/field'
      preLoaderRoute: typeof DashboardFieldsFieldIdSetupFieldImport
      parentRoute: typeof DashboardFieldsFieldIdSetupImport
    }
    '/dashboard/fields/$fieldId/setup/irrigation-system': {
      id: '/dashboard/fields/$fieldId/setup/irrigation-system'
      path: '/irrigation-system'
      fullPath: '/dashboard/fields/$fieldId/setup/irrigation-system'
      preLoaderRoute: typeof DashboardFieldsFieldIdSetupIrrigationSystemImport
      parentRoute: typeof DashboardFieldsFieldIdSetupImport
    }
    '/dashboard/fields/$fieldId/setup/management-zones': {
      id: '/dashboard/fields/$fieldId/setup/management-zones'
      path: '/management-zones'
      fullPath: '/dashboard/fields/$fieldId/setup/management-zones'
      preLoaderRoute: typeof DashboardFieldsFieldIdSetupManagementZonesImport
      parentRoute: typeof DashboardFieldsFieldIdSetupImport
    }
    '/dashboard/fields/$fieldId/setup/soil-management': {
      id: '/dashboard/fields/$fieldId/setup/soil-management'
      path: '/soil-management'
      fullPath: '/dashboard/fields/$fieldId/setup/soil-management'
      preLoaderRoute: typeof DashboardFieldsFieldIdSetupSoilManagementImport
      parentRoute: typeof DashboardFieldsFieldIdSetupImport
    }
    '/dashboard/fields/$fieldId/setup/treatment-sectors': {
      id: '/dashboard/fields/$fieldId/setup/treatment-sectors'
      path: '/treatment-sectors'
      fullPath: '/dashboard/fields/$fieldId/setup/treatment-sectors'
      preLoaderRoute: typeof DashboardFieldsFieldIdSetupTreatmentSectorsImport
      parentRoute: typeof DashboardFieldsFieldIdSetupImport
    }
    '/(auth)/password/reset/confirm/': {
      id: '/(auth)/password/reset/confirm/'
      path: '/password/reset/confirm'
      fullPath: '/password/reset/confirm'
      preLoaderRoute: typeof authPasswordResetConfirmIndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/fields/$fieldId/operations/': {
      id: '/dashboard/fields/$fieldId/operations/'
      path: '/'
      fullPath: '/dashboard/fields/$fieldId/operations/'
      preLoaderRoute: typeof DashboardFieldsFieldIdOperationsIndexImport
      parentRoute: typeof DashboardFieldsFieldIdOperationsImport
    }
    '/dashboard/fields/$fieldId/rx/': {
      id: '/dashboard/fields/$fieldId/rx/'
      path: '/'
      fullPath: '/dashboard/fields/$fieldId/rx/'
      preLoaderRoute: typeof DashboardFieldsFieldIdRxIndexImport
      parentRoute: typeof DashboardFieldsFieldIdRxImport
    }
    '/dashboard/fields/$fieldId/setup/': {
      id: '/dashboard/fields/$fieldId/setup/'
      path: '/'
      fullPath: '/dashboard/fields/$fieldId/setup/'
      preLoaderRoute: typeof DashboardFieldsFieldIdSetupIndexImport
      parentRoute: typeof DashboardFieldsFieldIdSetupImport
    }
    '/dashboard/fields/$fieldId/insights/hydroflow/settings': {
      id: '/dashboard/fields/$fieldId/insights/hydroflow/settings'
      path: '/settings'
      fullPath: '/dashboard/fields/$fieldId/insights/hydroflow/settings'
      preLoaderRoute: typeof DashboardFieldsFieldIdInsightsHydroflowSettingsImport
      parentRoute: typeof DashboardFieldsFieldIdInsightsHydroflowImport
    }
    '/dashboard/fields/$fieldId/operations/application/$applicationOperationId': {
      id: '/dashboard/fields/$fieldId/operations/application/$applicationOperationId'
      path: '/application/$applicationOperationId'
      fullPath: '/dashboard/fields/$fieldId/operations/application/$applicationOperationId'
      preLoaderRoute: typeof DashboardFieldsFieldIdOperationsApplicationApplicationOperationIdImport
      parentRoute: typeof DashboardFieldsFieldIdOperationsImport
    }
    '/dashboard/fields/$fieldId/operations/harvest/$harvestOperationId': {
      id: '/dashboard/fields/$fieldId/operations/harvest/$harvestOperationId'
      path: '/harvest/$harvestOperationId'
      fullPath: '/dashboard/fields/$fieldId/operations/harvest/$harvestOperationId'
      preLoaderRoute: typeof DashboardFieldsFieldIdOperationsHarvestHarvestOperationIdImport
      parentRoute: typeof DashboardFieldsFieldIdOperationsImport
    }
    '/dashboard/fields/$fieldId/operations/irrigation/$irrigationOperationId': {
      id: '/dashboard/fields/$fieldId/operations/irrigation/$irrigationOperationId'
      path: '/irrigation/$irrigationOperationId'
      fullPath: '/dashboard/fields/$fieldId/operations/irrigation/$irrigationOperationId'
      preLoaderRoute: typeof DashboardFieldsFieldIdOperationsIrrigationIrrigationOperationIdImport
      parentRoute: typeof DashboardFieldsFieldIdOperationsImport
    }
    '/dashboard/fields/$fieldId/operations/planting/$plantingOperationId': {
      id: '/dashboard/fields/$fieldId/operations/planting/$plantingOperationId'
      path: '/planting/$plantingOperationId'
      fullPath: '/dashboard/fields/$fieldId/operations/planting/$plantingOperationId'
      preLoaderRoute: typeof DashboardFieldsFieldIdOperationsPlantingPlantingOperationIdImport
      parentRoute: typeof DashboardFieldsFieldIdOperationsImport
    }
    '/dashboard/fields/$fieldId/insights/hydroflow/': {
      id: '/dashboard/fields/$fieldId/insights/hydroflow/'
      path: '/'
      fullPath: '/dashboard/fields/$fieldId/insights/hydroflow/'
      preLoaderRoute: typeof DashboardFieldsFieldIdInsightsHydroflowIndexImport
      parentRoute: typeof DashboardFieldsFieldIdInsightsHydroflowImport
    }
    '/dashboard/fields/$fieldId/rx/$rxId/': {
      id: '/dashboard/fields/$fieldId/rx/$rxId/'
      path: '/'
      fullPath: '/dashboard/fields/$fieldId/rx/$rxId/'
      preLoaderRoute: typeof DashboardFieldsFieldIdRxRxIdIndexImport
      parentRoute: typeof DashboardFieldsFieldIdRxRxIdImport
    }
    '/dashboard/fields/$fieldId/rx/$rxId/plots/$pairId': {
      id: '/dashboard/fields/$fieldId/rx/$rxId/plots/$pairId'
      path: '/plots/$pairId'
      fullPath: '/dashboard/fields/$fieldId/rx/$rxId/plots/$pairId'
      preLoaderRoute: typeof DashboardFieldsFieldIdRxRxIdPlotsPairIdImport
      parentRoute: typeof DashboardFieldsFieldIdRxRxIdImport
    }
    '/dashboard/fields/$fieldId/rx/$rxId/plots/draw': {
      id: '/dashboard/fields/$fieldId/rx/$rxId/plots/draw'
      path: '/plots/draw'
      fullPath: '/dashboard/fields/$fieldId/rx/$rxId/plots/draw'
      preLoaderRoute: typeof DashboardFieldsFieldIdRxRxIdPlotsDrawImport
      parentRoute: typeof DashboardFieldsFieldIdRxRxIdImport
    }
    '/dashboard/fields/$fieldId/rx/$rxId/plots/place': {
      id: '/dashboard/fields/$fieldId/rx/$rxId/plots/place'
      path: '/plots/place'
      fullPath: '/dashboard/fields/$fieldId/rx/$rxId/plots/place'
      preLoaderRoute: typeof DashboardFieldsFieldIdRxRxIdPlotsPlaceImport
      parentRoute: typeof DashboardFieldsFieldIdRxRxIdImport
    }
  }
}

// Create and export the route tree

interface DashboardAccountSettingsRouteChildren {
  DashboardAccountSettingsAccountRoute: typeof DashboardAccountSettingsAccountRoute
  DashboardAccountSettingsConnectionsRoute: typeof DashboardAccountSettingsConnectionsRoute
  DashboardAccountSettingsNotificationsRoute: typeof DashboardAccountSettingsNotificationsRoute
  DashboardAccountSettingsProductsRoute: typeof DashboardAccountSettingsProductsRoute
  DashboardAccountSettingsIndexRoute: typeof DashboardAccountSettingsIndexRoute
}

const DashboardAccountSettingsRouteChildren: DashboardAccountSettingsRouteChildren =
  {
    DashboardAccountSettingsAccountRoute: DashboardAccountSettingsAccountRoute,
    DashboardAccountSettingsConnectionsRoute:
      DashboardAccountSettingsConnectionsRoute,
    DashboardAccountSettingsNotificationsRoute:
      DashboardAccountSettingsNotificationsRoute,
    DashboardAccountSettingsProductsRoute:
      DashboardAccountSettingsProductsRoute,
    DashboardAccountSettingsIndexRoute: DashboardAccountSettingsIndexRoute,
  }

const DashboardAccountSettingsRouteWithChildren =
  DashboardAccountSettingsRoute._addFileChildren(
    DashboardAccountSettingsRouteChildren,
  )

interface DashboardEnrollmentRouteChildren {
  DashboardEnrollmentContractsRoute: typeof DashboardEnrollmentContractsRoute
  DashboardEnrollmentFieldsRoute: typeof DashboardEnrollmentFieldsRoute
  DashboardEnrollmentIndexRoute: typeof DashboardEnrollmentIndexRoute
}

const DashboardEnrollmentRouteChildren: DashboardEnrollmentRouteChildren = {
  DashboardEnrollmentContractsRoute: DashboardEnrollmentContractsRoute,
  DashboardEnrollmentFieldsRoute: DashboardEnrollmentFieldsRoute,
  DashboardEnrollmentIndexRoute: DashboardEnrollmentIndexRoute,
}

const DashboardEnrollmentRouteWithChildren =
  DashboardEnrollmentRoute._addFileChildren(DashboardEnrollmentRouteChildren)

interface DashboardFieldsFieldIdInsightsHydroflowRouteChildren {
  DashboardFieldsFieldIdInsightsHydroflowSettingsRoute: typeof DashboardFieldsFieldIdInsightsHydroflowSettingsRoute
  DashboardFieldsFieldIdInsightsHydroflowIndexRoute: typeof DashboardFieldsFieldIdInsightsHydroflowIndexRoute
}

const DashboardFieldsFieldIdInsightsHydroflowRouteChildren: DashboardFieldsFieldIdInsightsHydroflowRouteChildren =
  {
    DashboardFieldsFieldIdInsightsHydroflowSettingsRoute:
      DashboardFieldsFieldIdInsightsHydroflowSettingsRoute,
    DashboardFieldsFieldIdInsightsHydroflowIndexRoute:
      DashboardFieldsFieldIdInsightsHydroflowIndexRoute,
  }

const DashboardFieldsFieldIdInsightsHydroflowRouteWithChildren =
  DashboardFieldsFieldIdInsightsHydroflowRoute._addFileChildren(
    DashboardFieldsFieldIdInsightsHydroflowRouteChildren,
  )

interface DashboardFieldsFieldIdInsightsRouteChildren {
  DashboardFieldsFieldIdInsightsDevelopmentRoute: typeof DashboardFieldsFieldIdInsightsDevelopmentRoute
  DashboardFieldsFieldIdInsightsHydroflowRoute: typeof DashboardFieldsFieldIdInsightsHydroflowRouteWithChildren
  DashboardFieldsFieldIdInsightsNtimeRoute: typeof DashboardFieldsFieldIdInsightsNtimeRoute
  DashboardFieldsFieldIdInsightsSamplesRoute: typeof DashboardFieldsFieldIdInsightsSamplesRoute
  DashboardFieldsFieldIdInsightsSettingsRoute: typeof DashboardFieldsFieldIdInsightsSettingsRoute
  DashboardFieldsFieldIdInsightsWeatherRoute: typeof DashboardFieldsFieldIdInsightsWeatherRoute
}

const DashboardFieldsFieldIdInsightsRouteChildren: DashboardFieldsFieldIdInsightsRouteChildren =
  {
    DashboardFieldsFieldIdInsightsDevelopmentRoute:
      DashboardFieldsFieldIdInsightsDevelopmentRoute,
    DashboardFieldsFieldIdInsightsHydroflowRoute:
      DashboardFieldsFieldIdInsightsHydroflowRouteWithChildren,
    DashboardFieldsFieldIdInsightsNtimeRoute:
      DashboardFieldsFieldIdInsightsNtimeRoute,
    DashboardFieldsFieldIdInsightsSamplesRoute:
      DashboardFieldsFieldIdInsightsSamplesRoute,
    DashboardFieldsFieldIdInsightsSettingsRoute:
      DashboardFieldsFieldIdInsightsSettingsRoute,
    DashboardFieldsFieldIdInsightsWeatherRoute:
      DashboardFieldsFieldIdInsightsWeatherRoute,
  }

const DashboardFieldsFieldIdInsightsRouteWithChildren =
  DashboardFieldsFieldIdInsightsRoute._addFileChildren(
    DashboardFieldsFieldIdInsightsRouteChildren,
  )

interface DashboardFieldsFieldIdOperationsRouteChildren {
  DashboardFieldsFieldIdOperationsAddRoute: typeof DashboardFieldsFieldIdOperationsAddRoute
  DashboardFieldsFieldIdOperationsIndexRoute: typeof DashboardFieldsFieldIdOperationsIndexRoute
  DashboardFieldsFieldIdOperationsApplicationApplicationOperationIdRoute: typeof DashboardFieldsFieldIdOperationsApplicationApplicationOperationIdRoute
  DashboardFieldsFieldIdOperationsHarvestHarvestOperationIdRoute: typeof DashboardFieldsFieldIdOperationsHarvestHarvestOperationIdRoute
  DashboardFieldsFieldIdOperationsIrrigationIrrigationOperationIdRoute: typeof DashboardFieldsFieldIdOperationsIrrigationIrrigationOperationIdRoute
  DashboardFieldsFieldIdOperationsPlantingPlantingOperationIdRoute: typeof DashboardFieldsFieldIdOperationsPlantingPlantingOperationIdRoute
}

const DashboardFieldsFieldIdOperationsRouteChildren: DashboardFieldsFieldIdOperationsRouteChildren =
  {
    DashboardFieldsFieldIdOperationsAddRoute:
      DashboardFieldsFieldIdOperationsAddRoute,
    DashboardFieldsFieldIdOperationsIndexRoute:
      DashboardFieldsFieldIdOperationsIndexRoute,
    DashboardFieldsFieldIdOperationsApplicationApplicationOperationIdRoute:
      DashboardFieldsFieldIdOperationsApplicationApplicationOperationIdRoute,
    DashboardFieldsFieldIdOperationsHarvestHarvestOperationIdRoute:
      DashboardFieldsFieldIdOperationsHarvestHarvestOperationIdRoute,
    DashboardFieldsFieldIdOperationsIrrigationIrrigationOperationIdRoute:
      DashboardFieldsFieldIdOperationsIrrigationIrrigationOperationIdRoute,
    DashboardFieldsFieldIdOperationsPlantingPlantingOperationIdRoute:
      DashboardFieldsFieldIdOperationsPlantingPlantingOperationIdRoute,
  }

const DashboardFieldsFieldIdOperationsRouteWithChildren =
  DashboardFieldsFieldIdOperationsRoute._addFileChildren(
    DashboardFieldsFieldIdOperationsRouteChildren,
  )

interface DashboardFieldsFieldIdRxRxIdRouteChildren {
  DashboardFieldsFieldIdRxRxIdIndexRoute: typeof DashboardFieldsFieldIdRxRxIdIndexRoute
  DashboardFieldsFieldIdRxRxIdPlotsPairIdRoute: typeof DashboardFieldsFieldIdRxRxIdPlotsPairIdRoute
  DashboardFieldsFieldIdRxRxIdPlotsDrawRoute: typeof DashboardFieldsFieldIdRxRxIdPlotsDrawRoute
  DashboardFieldsFieldIdRxRxIdPlotsPlaceRoute: typeof DashboardFieldsFieldIdRxRxIdPlotsPlaceRoute
}

const DashboardFieldsFieldIdRxRxIdRouteChildren: DashboardFieldsFieldIdRxRxIdRouteChildren =
  {
    DashboardFieldsFieldIdRxRxIdIndexRoute:
      DashboardFieldsFieldIdRxRxIdIndexRoute,
    DashboardFieldsFieldIdRxRxIdPlotsPairIdRoute:
      DashboardFieldsFieldIdRxRxIdPlotsPairIdRoute,
    DashboardFieldsFieldIdRxRxIdPlotsDrawRoute:
      DashboardFieldsFieldIdRxRxIdPlotsDrawRoute,
    DashboardFieldsFieldIdRxRxIdPlotsPlaceRoute:
      DashboardFieldsFieldIdRxRxIdPlotsPlaceRoute,
  }

const DashboardFieldsFieldIdRxRxIdRouteWithChildren =
  DashboardFieldsFieldIdRxRxIdRoute._addFileChildren(
    DashboardFieldsFieldIdRxRxIdRouteChildren,
  )

interface DashboardFieldsFieldIdRxRouteChildren {
  DashboardFieldsFieldIdRxRxIdRoute: typeof DashboardFieldsFieldIdRxRxIdRouteWithChildren
  DashboardFieldsFieldIdRxNewRoute: typeof DashboardFieldsFieldIdRxNewRoute
  DashboardFieldsFieldIdRxIndexRoute: typeof DashboardFieldsFieldIdRxIndexRoute
}

const DashboardFieldsFieldIdRxRouteChildren: DashboardFieldsFieldIdRxRouteChildren =
  {
    DashboardFieldsFieldIdRxRxIdRoute:
      DashboardFieldsFieldIdRxRxIdRouteWithChildren,
    DashboardFieldsFieldIdRxNewRoute: DashboardFieldsFieldIdRxNewRoute,
    DashboardFieldsFieldIdRxIndexRoute: DashboardFieldsFieldIdRxIndexRoute,
  }

const DashboardFieldsFieldIdRxRouteWithChildren =
  DashboardFieldsFieldIdRxRoute._addFileChildren(
    DashboardFieldsFieldIdRxRouteChildren,
  )

interface DashboardFieldsFieldIdSetupRouteChildren {
  DashboardFieldsFieldIdSetupChemigationSystemsRoute: typeof DashboardFieldsFieldIdSetupChemigationSystemsRoute
  DashboardFieldsFieldIdSetupFertilizerPreferencesRoute: typeof DashboardFieldsFieldIdSetupFertilizerPreferencesRoute
  DashboardFieldsFieldIdSetupFieldRoute: typeof DashboardFieldsFieldIdSetupFieldRoute
  DashboardFieldsFieldIdSetupIrrigationSystemRoute: typeof DashboardFieldsFieldIdSetupIrrigationSystemRoute
  DashboardFieldsFieldIdSetupManagementZonesRoute: typeof DashboardFieldsFieldIdSetupManagementZonesRoute
  DashboardFieldsFieldIdSetupSoilManagementRoute: typeof DashboardFieldsFieldIdSetupSoilManagementRoute
  DashboardFieldsFieldIdSetupTreatmentSectorsRoute: typeof DashboardFieldsFieldIdSetupTreatmentSectorsRoute
  DashboardFieldsFieldIdSetupIndexRoute: typeof DashboardFieldsFieldIdSetupIndexRoute
}

const DashboardFieldsFieldIdSetupRouteChildren: DashboardFieldsFieldIdSetupRouteChildren =
  {
    DashboardFieldsFieldIdSetupChemigationSystemsRoute:
      DashboardFieldsFieldIdSetupChemigationSystemsRoute,
    DashboardFieldsFieldIdSetupFertilizerPreferencesRoute:
      DashboardFieldsFieldIdSetupFertilizerPreferencesRoute,
    DashboardFieldsFieldIdSetupFieldRoute:
      DashboardFieldsFieldIdSetupFieldRoute,
    DashboardFieldsFieldIdSetupIrrigationSystemRoute:
      DashboardFieldsFieldIdSetupIrrigationSystemRoute,
    DashboardFieldsFieldIdSetupManagementZonesRoute:
      DashboardFieldsFieldIdSetupManagementZonesRoute,
    DashboardFieldsFieldIdSetupSoilManagementRoute:
      DashboardFieldsFieldIdSetupSoilManagementRoute,
    DashboardFieldsFieldIdSetupTreatmentSectorsRoute:
      DashboardFieldsFieldIdSetupTreatmentSectorsRoute,
    DashboardFieldsFieldIdSetupIndexRoute:
      DashboardFieldsFieldIdSetupIndexRoute,
  }

const DashboardFieldsFieldIdSetupRouteWithChildren =
  DashboardFieldsFieldIdSetupRoute._addFileChildren(
    DashboardFieldsFieldIdSetupRouteChildren,
  )

interface DashboardFieldsFieldIdRouteChildren {
  DashboardFieldsFieldIdInsightsRoute: typeof DashboardFieldsFieldIdInsightsRouteWithChildren
  DashboardFieldsFieldIdOperationsRoute: typeof DashboardFieldsFieldIdOperationsRouteWithChildren
  DashboardFieldsFieldIdRxRoute: typeof DashboardFieldsFieldIdRxRouteWithChildren
  DashboardFieldsFieldIdSetupRoute: typeof DashboardFieldsFieldIdSetupRouteWithChildren
}

const DashboardFieldsFieldIdRouteChildren: DashboardFieldsFieldIdRouteChildren =
  {
    DashboardFieldsFieldIdInsightsRoute:
      DashboardFieldsFieldIdInsightsRouteWithChildren,
    DashboardFieldsFieldIdOperationsRoute:
      DashboardFieldsFieldIdOperationsRouteWithChildren,
    DashboardFieldsFieldIdRxRoute: DashboardFieldsFieldIdRxRouteWithChildren,
    DashboardFieldsFieldIdSetupRoute:
      DashboardFieldsFieldIdSetupRouteWithChildren,
  }

const DashboardFieldsFieldIdRouteWithChildren =
  DashboardFieldsFieldIdRoute._addFileChildren(
    DashboardFieldsFieldIdRouteChildren,
  )

interface DashboardFieldsAddRouteChildren {
  DashboardFieldsAddDrawRoute: typeof DashboardFieldsAddDrawRoute
  DashboardFieldsAddImportRoute: typeof DashboardFieldsAddImportRoute
}

const DashboardFieldsAddRouteChildren: DashboardFieldsAddRouteChildren = {
  DashboardFieldsAddDrawRoute: DashboardFieldsAddDrawRoute,
  DashboardFieldsAddImportRoute: DashboardFieldsAddImportRoute,
}

const DashboardFieldsAddRouteWithChildren =
  DashboardFieldsAddRoute._addFileChildren(DashboardFieldsAddRouteChildren)

interface DashboardFieldsRouteChildren {
  DashboardFieldsFieldIdRoute: typeof DashboardFieldsFieldIdRouteWithChildren
  DashboardFieldsAddRoute: typeof DashboardFieldsAddRouteWithChildren
  DashboardFieldsAddBulkRoute: typeof DashboardFieldsAddBulkRoute
  DashboardFieldsIndexRoute: typeof DashboardFieldsIndexRoute
}

const DashboardFieldsRouteChildren: DashboardFieldsRouteChildren = {
  DashboardFieldsFieldIdRoute: DashboardFieldsFieldIdRouteWithChildren,
  DashboardFieldsAddRoute: DashboardFieldsAddRouteWithChildren,
  DashboardFieldsAddBulkRoute: DashboardFieldsAddBulkRoute,
  DashboardFieldsIndexRoute: DashboardFieldsIndexRoute,
}

const DashboardFieldsRouteWithChildren = DashboardFieldsRoute._addFileChildren(
  DashboardFieldsRouteChildren,
)

interface DashboardHomeRouteChildren {
  DashboardHomeBulkRxRoute: typeof DashboardHomeBulkRxRoute
  DashboardHomeDashboardRoute: typeof DashboardHomeDashboardRoute
  DashboardHomeFieldConfigRoute: typeof DashboardHomeFieldConfigRoute
  DashboardHomeImageryQaqcRoute: typeof DashboardHomeImageryQaqcRoute
  DashboardHomeInsightsRoute: typeof DashboardHomeInsightsRoute
  DashboardHomeSyncedOperationsRoute: typeof DashboardHomeSyncedOperationsRoute
  DashboardHomeIndexRoute: typeof DashboardHomeIndexRoute
}

const DashboardHomeRouteChildren: DashboardHomeRouteChildren = {
  DashboardHomeBulkRxRoute: DashboardHomeBulkRxRoute,
  DashboardHomeDashboardRoute: DashboardHomeDashboardRoute,
  DashboardHomeFieldConfigRoute: DashboardHomeFieldConfigRoute,
  DashboardHomeImageryQaqcRoute: DashboardHomeImageryQaqcRoute,
  DashboardHomeInsightsRoute: DashboardHomeInsightsRoute,
  DashboardHomeSyncedOperationsRoute: DashboardHomeSyncedOperationsRoute,
  DashboardHomeIndexRoute: DashboardHomeIndexRoute,
}

const DashboardHomeRouteWithChildren = DashboardHomeRoute._addFileChildren(
  DashboardHomeRouteChildren,
)

interface DashboardNetworkOrganizationsRouteChildren {
  DashboardNetworkOrganizationsOrganizationIdRoute: typeof DashboardNetworkOrganizationsOrganizationIdRoute
  DashboardNetworkOrganizationsNewRoute: typeof DashboardNetworkOrganizationsNewRoute
}

const DashboardNetworkOrganizationsRouteChildren: DashboardNetworkOrganizationsRouteChildren =
  {
    DashboardNetworkOrganizationsOrganizationIdRoute:
      DashboardNetworkOrganizationsOrganizationIdRoute,
    DashboardNetworkOrganizationsNewRoute:
      DashboardNetworkOrganizationsNewRoute,
  }

const DashboardNetworkOrganizationsRouteWithChildren =
  DashboardNetworkOrganizationsRoute._addFileChildren(
    DashboardNetworkOrganizationsRouteChildren,
  )

interface DashboardNetworkUsersRouteChildren {
  DashboardNetworkUsersUserIdRoute: typeof DashboardNetworkUsersUserIdRoute
  DashboardNetworkUsersNewRoute: typeof DashboardNetworkUsersNewRoute
}

const DashboardNetworkUsersRouteChildren: DashboardNetworkUsersRouteChildren = {
  DashboardNetworkUsersUserIdRoute: DashboardNetworkUsersUserIdRoute,
  DashboardNetworkUsersNewRoute: DashboardNetworkUsersNewRoute,
}

const DashboardNetworkUsersRouteWithChildren =
  DashboardNetworkUsersRoute._addFileChildren(
    DashboardNetworkUsersRouteChildren,
  )

interface DashboardNetworkRouteChildren {
  DashboardNetworkSplatRoute: typeof DashboardNetworkSplatRoute
  DashboardNetworkOrganizationsRoute: typeof DashboardNetworkOrganizationsRouteWithChildren
  DashboardNetworkUsersRoute: typeof DashboardNetworkUsersRouteWithChildren
  DashboardNetworkIndexRoute: typeof DashboardNetworkIndexRoute
}

const DashboardNetworkRouteChildren: DashboardNetworkRouteChildren = {
  DashboardNetworkSplatRoute: DashboardNetworkSplatRoute,
  DashboardNetworkOrganizationsRoute:
    DashboardNetworkOrganizationsRouteWithChildren,
  DashboardNetworkUsersRoute: DashboardNetworkUsersRouteWithChildren,
  DashboardNetworkIndexRoute: DashboardNetworkIndexRoute,
}

const DashboardNetworkRouteWithChildren =
  DashboardNetworkRoute._addFileChildren(DashboardNetworkRouteChildren)

interface DashboardRouteChildren {
  DashboardAccountSettingsRoute: typeof DashboardAccountSettingsRouteWithChildren
  DashboardAddFieldRoute: typeof DashboardAddFieldRoute
  DashboardEnrollmentRoute: typeof DashboardEnrollmentRouteWithChildren
  DashboardFieldsRoute: typeof DashboardFieldsRouteWithChildren
  DashboardHomeRoute: typeof DashboardHomeRouteWithChildren
  DashboardNetworkRoute: typeof DashboardNetworkRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardAllNSplatRoute: typeof DashboardAllNSplatRoute
  DashboardDocumentationIndexRoute: typeof DashboardDocumentationIndexRoute
  DashboardFieldFieldIdSplatRoute: typeof DashboardFieldFieldIdSplatRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAccountSettingsRoute: DashboardAccountSettingsRouteWithChildren,
  DashboardAddFieldRoute: DashboardAddFieldRoute,
  DashboardEnrollmentRoute: DashboardEnrollmentRouteWithChildren,
  DashboardFieldsRoute: DashboardFieldsRouteWithChildren,
  DashboardHomeRoute: DashboardHomeRouteWithChildren,
  DashboardNetworkRoute: DashboardNetworkRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardAllNSplatRoute: DashboardAllNSplatRoute,
  DashboardDocumentationIndexRoute: DashboardDocumentationIndexRoute,
  DashboardFieldFieldIdSplatRoute: DashboardFieldFieldIdSplatRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface authRegisterRouteChildren {
  authRegisterCspSlugRoute: typeof authRegisterCspSlugRoute
  authRegisterSelectCspRoute: typeof authRegisterSelectCspRoute
  authRegisterIndexRoute: typeof authRegisterIndexRoute
  authRegisterPartnerSplatRoute: typeof authRegisterPartnerSplatRoute
}

const authRegisterRouteChildren: authRegisterRouteChildren = {
  authRegisterCspSlugRoute: authRegisterCspSlugRoute,
  authRegisterSelectCspRoute: authRegisterSelectCspRoute,
  authRegisterIndexRoute: authRegisterIndexRoute,
  authRegisterPartnerSplatRoute: authRegisterPartnerSplatRoute,
}

const authRegisterRouteWithChildren = authRegisterRoute._addFileChildren(
  authRegisterRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/public-csp-locator': typeof PublicCspLocatorRoute
  '/auth': typeof authAuthRoute
  '/csp-locator-map': typeof authCspLocatorMapRoute
  '/register': typeof authRegisterRouteWithChildren
  '/dashboard/account-settings': typeof DashboardAccountSettingsRouteWithChildren
  '/dashboard/add-field': typeof DashboardAddFieldRoute
  '/dashboard/enrollment': typeof DashboardEnrollmentRouteWithChildren
  '/dashboard/fields': typeof DashboardFieldsRouteWithChildren
  '/dashboard/home': typeof DashboardHomeRouteWithChildren
  '/dashboard/network': typeof DashboardNetworkRouteWithChildren
  '/ntimev1/$': typeof Ntimev1SplatRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/auth-redirect/$platform': typeof authAuthRedirectPlatformRoute
  '/register/$cspSlug': typeof authRegisterCspSlugRoute
  '/register/select-csp': typeof authRegisterSelectCspRoute
  '/dashboard/account-settings/account': typeof DashboardAccountSettingsAccountRoute
  '/dashboard/account-settings/connections': typeof DashboardAccountSettingsConnectionsRoute
  '/dashboard/account-settings/notifications': typeof DashboardAccountSettingsNotificationsRoute
  '/dashboard/account-settings/products': typeof DashboardAccountSettingsProductsRoute
  '/dashboard/all-n/$': typeof DashboardAllNSplatRoute
  '/dashboard/enrollment/contracts': typeof DashboardEnrollmentContractsRoute
  '/dashboard/enrollment/fields': typeof DashboardEnrollmentFieldsRoute
  '/dashboard/fields/$fieldId': typeof DashboardFieldsFieldIdRouteWithChildren
  '/dashboard/fields/add': typeof DashboardFieldsAddRouteWithChildren
  '/dashboard/fields/add-bulk': typeof DashboardFieldsAddBulkRoute
  '/dashboard/home/bulk-rx': typeof DashboardHomeBulkRxRoute
  '/dashboard/home/dashboard': typeof DashboardHomeDashboardRoute
  '/dashboard/home/field-config': typeof DashboardHomeFieldConfigRoute
  '/dashboard/home/imagery-qaqc': typeof DashboardHomeImageryQaqcRoute
  '/dashboard/home/insights': typeof DashboardHomeInsightsRoute
  '/dashboard/home/synced-operations': typeof DashboardHomeSyncedOperationsRoute
  '/dashboard/network/$': typeof DashboardNetworkSplatRoute
  '/dashboard/network/organizations': typeof DashboardNetworkOrganizationsRouteWithChildren
  '/dashboard/network/users': typeof DashboardNetworkUsersRouteWithChildren
  '/register/': typeof authRegisterIndexRoute
  '/dashboard/account-settings/': typeof DashboardAccountSettingsIndexRoute
  '/dashboard/documentation': typeof DashboardDocumentationIndexRoute
  '/dashboard/enrollment/': typeof DashboardEnrollmentIndexRoute
  '/dashboard/fields/': typeof DashboardFieldsIndexRoute
  '/dashboard/home/': typeof DashboardHomeIndexRoute
  '/dashboard/network/': typeof DashboardNetworkIndexRoute
  '/register/partner/$': typeof authRegisterPartnerSplatRoute
  '/dashboard/field/$fieldId/$': typeof DashboardFieldFieldIdSplatRoute
  '/dashboard/fields/$fieldId/insights': typeof DashboardFieldsFieldIdInsightsRouteWithChildren
  '/dashboard/fields/$fieldId/operations': typeof DashboardFieldsFieldIdOperationsRouteWithChildren
  '/dashboard/fields/$fieldId/rx': typeof DashboardFieldsFieldIdRxRouteWithChildren
  '/dashboard/fields/$fieldId/setup': typeof DashboardFieldsFieldIdSetupRouteWithChildren
  '/dashboard/fields/add/draw': typeof DashboardFieldsAddDrawRoute
  '/dashboard/fields/add/import': typeof DashboardFieldsAddImportRoute
  '/dashboard/network/organizations/$organizationId': typeof DashboardNetworkOrganizationsOrganizationIdRoute
  '/dashboard/network/organizations/new': typeof DashboardNetworkOrganizationsNewRoute
  '/dashboard/network/users/$userId': typeof DashboardNetworkUsersUserIdRoute
  '/dashboard/network/users/new': typeof DashboardNetworkUsersNewRoute
  '/password/reset': typeof authPasswordResetIndexRoute
  '/dashboard/fields/$fieldId/insights/development': typeof DashboardFieldsFieldIdInsightsDevelopmentRoute
  '/dashboard/fields/$fieldId/insights/hydroflow': typeof DashboardFieldsFieldIdInsightsHydroflowRouteWithChildren
  '/dashboard/fields/$fieldId/insights/ntime': typeof DashboardFieldsFieldIdInsightsNtimeRoute
  '/dashboard/fields/$fieldId/insights/samples': typeof DashboardFieldsFieldIdInsightsSamplesRoute
  '/dashboard/fields/$fieldId/insights/settings': typeof DashboardFieldsFieldIdInsightsSettingsRoute
  '/dashboard/fields/$fieldId/insights/weather': typeof DashboardFieldsFieldIdInsightsWeatherRoute
  '/dashboard/fields/$fieldId/operations/add': typeof DashboardFieldsFieldIdOperationsAddRoute
  '/dashboard/fields/$fieldId/rx/$rxId': typeof DashboardFieldsFieldIdRxRxIdRouteWithChildren
  '/dashboard/fields/$fieldId/rx/new': typeof DashboardFieldsFieldIdRxNewRoute
  '/dashboard/fields/$fieldId/setup/chemigation-systems': typeof DashboardFieldsFieldIdSetupChemigationSystemsRoute
  '/dashboard/fields/$fieldId/setup/fertilizer-preferences': typeof DashboardFieldsFieldIdSetupFertilizerPreferencesRoute
  '/dashboard/fields/$fieldId/setup/field': typeof DashboardFieldsFieldIdSetupFieldRoute
  '/dashboard/fields/$fieldId/setup/irrigation-system': typeof DashboardFieldsFieldIdSetupIrrigationSystemRoute
  '/dashboard/fields/$fieldId/setup/management-zones': typeof DashboardFieldsFieldIdSetupManagementZonesRoute
  '/dashboard/fields/$fieldId/setup/soil-management': typeof DashboardFieldsFieldIdSetupSoilManagementRoute
  '/dashboard/fields/$fieldId/setup/treatment-sectors': typeof DashboardFieldsFieldIdSetupTreatmentSectorsRoute
  '/password/reset/confirm': typeof authPasswordResetConfirmIndexRoute
  '/dashboard/fields/$fieldId/operations/': typeof DashboardFieldsFieldIdOperationsIndexRoute
  '/dashboard/fields/$fieldId/rx/': typeof DashboardFieldsFieldIdRxIndexRoute
  '/dashboard/fields/$fieldId/setup/': typeof DashboardFieldsFieldIdSetupIndexRoute
  '/dashboard/fields/$fieldId/insights/hydroflow/settings': typeof DashboardFieldsFieldIdInsightsHydroflowSettingsRoute
  '/dashboard/fields/$fieldId/operations/application/$applicationOperationId': typeof DashboardFieldsFieldIdOperationsApplicationApplicationOperationIdRoute
  '/dashboard/fields/$fieldId/operations/harvest/$harvestOperationId': typeof DashboardFieldsFieldIdOperationsHarvestHarvestOperationIdRoute
  '/dashboard/fields/$fieldId/operations/irrigation/$irrigationOperationId': typeof DashboardFieldsFieldIdOperationsIrrigationIrrigationOperationIdRoute
  '/dashboard/fields/$fieldId/operations/planting/$plantingOperationId': typeof DashboardFieldsFieldIdOperationsPlantingPlantingOperationIdRoute
  '/dashboard/fields/$fieldId/insights/hydroflow/': typeof DashboardFieldsFieldIdInsightsHydroflowIndexRoute
  '/dashboard/fields/$fieldId/rx/$rxId/': typeof DashboardFieldsFieldIdRxRxIdIndexRoute
  '/dashboard/fields/$fieldId/rx/$rxId/plots/$pairId': typeof DashboardFieldsFieldIdRxRxIdPlotsPairIdRoute
  '/dashboard/fields/$fieldId/rx/$rxId/plots/draw': typeof DashboardFieldsFieldIdRxRxIdPlotsDrawRoute
  '/dashboard/fields/$fieldId/rx/$rxId/plots/place': typeof DashboardFieldsFieldIdRxRxIdPlotsPlaceRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/public-csp-locator': typeof PublicCspLocatorRoute
  '/auth': typeof authAuthRoute
  '/csp-locator-map': typeof authCspLocatorMapRoute
  '/dashboard/add-field': typeof DashboardAddFieldRoute
  '/ntimev1/$': typeof Ntimev1SplatRoute
  '/dashboard': typeof DashboardIndexRoute
  '/auth-redirect/$platform': typeof authAuthRedirectPlatformRoute
  '/register/$cspSlug': typeof authRegisterCspSlugRoute
  '/register/select-csp': typeof authRegisterSelectCspRoute
  '/dashboard/account-settings/account': typeof DashboardAccountSettingsAccountRoute
  '/dashboard/account-settings/connections': typeof DashboardAccountSettingsConnectionsRoute
  '/dashboard/account-settings/notifications': typeof DashboardAccountSettingsNotificationsRoute
  '/dashboard/account-settings/products': typeof DashboardAccountSettingsProductsRoute
  '/dashboard/all-n/$': typeof DashboardAllNSplatRoute
  '/dashboard/enrollment/contracts': typeof DashboardEnrollmentContractsRoute
  '/dashboard/enrollment/fields': typeof DashboardEnrollmentFieldsRoute
  '/dashboard/fields/$fieldId': typeof DashboardFieldsFieldIdRouteWithChildren
  '/dashboard/fields/add': typeof DashboardFieldsAddRouteWithChildren
  '/dashboard/fields/add-bulk': typeof DashboardFieldsAddBulkRoute
  '/dashboard/home/bulk-rx': typeof DashboardHomeBulkRxRoute
  '/dashboard/home/dashboard': typeof DashboardHomeDashboardRoute
  '/dashboard/home/field-config': typeof DashboardHomeFieldConfigRoute
  '/dashboard/home/imagery-qaqc': typeof DashboardHomeImageryQaqcRoute
  '/dashboard/home/insights': typeof DashboardHomeInsightsRoute
  '/dashboard/home/synced-operations': typeof DashboardHomeSyncedOperationsRoute
  '/dashboard/network/$': typeof DashboardNetworkSplatRoute
  '/dashboard/network/organizations': typeof DashboardNetworkOrganizationsRouteWithChildren
  '/dashboard/network/users': typeof DashboardNetworkUsersRouteWithChildren
  '/register': typeof authRegisterIndexRoute
  '/dashboard/account-settings': typeof DashboardAccountSettingsIndexRoute
  '/dashboard/documentation': typeof DashboardDocumentationIndexRoute
  '/dashboard/enrollment': typeof DashboardEnrollmentIndexRoute
  '/dashboard/fields': typeof DashboardFieldsIndexRoute
  '/dashboard/home': typeof DashboardHomeIndexRoute
  '/dashboard/network': typeof DashboardNetworkIndexRoute
  '/register/partner/$': typeof authRegisterPartnerSplatRoute
  '/dashboard/field/$fieldId/$': typeof DashboardFieldFieldIdSplatRoute
  '/dashboard/fields/$fieldId/insights': typeof DashboardFieldsFieldIdInsightsRouteWithChildren
  '/dashboard/fields/add/draw': typeof DashboardFieldsAddDrawRoute
  '/dashboard/fields/add/import': typeof DashboardFieldsAddImportRoute
  '/dashboard/network/organizations/$organizationId': typeof DashboardNetworkOrganizationsOrganizationIdRoute
  '/dashboard/network/organizations/new': typeof DashboardNetworkOrganizationsNewRoute
  '/dashboard/network/users/$userId': typeof DashboardNetworkUsersUserIdRoute
  '/dashboard/network/users/new': typeof DashboardNetworkUsersNewRoute
  '/password/reset': typeof authPasswordResetIndexRoute
  '/dashboard/fields/$fieldId/insights/development': typeof DashboardFieldsFieldIdInsightsDevelopmentRoute
  '/dashboard/fields/$fieldId/insights/ntime': typeof DashboardFieldsFieldIdInsightsNtimeRoute
  '/dashboard/fields/$fieldId/insights/samples': typeof DashboardFieldsFieldIdInsightsSamplesRoute
  '/dashboard/fields/$fieldId/insights/settings': typeof DashboardFieldsFieldIdInsightsSettingsRoute
  '/dashboard/fields/$fieldId/insights/weather': typeof DashboardFieldsFieldIdInsightsWeatherRoute
  '/dashboard/fields/$fieldId/operations/add': typeof DashboardFieldsFieldIdOperationsAddRoute
  '/dashboard/fields/$fieldId/rx/new': typeof DashboardFieldsFieldIdRxNewRoute
  '/dashboard/fields/$fieldId/setup/chemigation-systems': typeof DashboardFieldsFieldIdSetupChemigationSystemsRoute
  '/dashboard/fields/$fieldId/setup/fertilizer-preferences': typeof DashboardFieldsFieldIdSetupFertilizerPreferencesRoute
  '/dashboard/fields/$fieldId/setup/field': typeof DashboardFieldsFieldIdSetupFieldRoute
  '/dashboard/fields/$fieldId/setup/irrigation-system': typeof DashboardFieldsFieldIdSetupIrrigationSystemRoute
  '/dashboard/fields/$fieldId/setup/management-zones': typeof DashboardFieldsFieldIdSetupManagementZonesRoute
  '/dashboard/fields/$fieldId/setup/soil-management': typeof DashboardFieldsFieldIdSetupSoilManagementRoute
  '/dashboard/fields/$fieldId/setup/treatment-sectors': typeof DashboardFieldsFieldIdSetupTreatmentSectorsRoute
  '/password/reset/confirm': typeof authPasswordResetConfirmIndexRoute
  '/dashboard/fields/$fieldId/operations': typeof DashboardFieldsFieldIdOperationsIndexRoute
  '/dashboard/fields/$fieldId/rx': typeof DashboardFieldsFieldIdRxIndexRoute
  '/dashboard/fields/$fieldId/setup': typeof DashboardFieldsFieldIdSetupIndexRoute
  '/dashboard/fields/$fieldId/insights/hydroflow/settings': typeof DashboardFieldsFieldIdInsightsHydroflowSettingsRoute
  '/dashboard/fields/$fieldId/operations/application/$applicationOperationId': typeof DashboardFieldsFieldIdOperationsApplicationApplicationOperationIdRoute
  '/dashboard/fields/$fieldId/operations/harvest/$harvestOperationId': typeof DashboardFieldsFieldIdOperationsHarvestHarvestOperationIdRoute
  '/dashboard/fields/$fieldId/operations/irrigation/$irrigationOperationId': typeof DashboardFieldsFieldIdOperationsIrrigationIrrigationOperationIdRoute
  '/dashboard/fields/$fieldId/operations/planting/$plantingOperationId': typeof DashboardFieldsFieldIdOperationsPlantingPlantingOperationIdRoute
  '/dashboard/fields/$fieldId/insights/hydroflow': typeof DashboardFieldsFieldIdInsightsHydroflowIndexRoute
  '/dashboard/fields/$fieldId/rx/$rxId': typeof DashboardFieldsFieldIdRxRxIdIndexRoute
  '/dashboard/fields/$fieldId/rx/$rxId/plots/$pairId': typeof DashboardFieldsFieldIdRxRxIdPlotsPairIdRoute
  '/dashboard/fields/$fieldId/rx/$rxId/plots/draw': typeof DashboardFieldsFieldIdRxRxIdPlotsDrawRoute
  '/dashboard/fields/$fieldId/rx/$rxId/plots/place': typeof DashboardFieldsFieldIdRxRxIdPlotsPlaceRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/public-csp-locator': typeof PublicCspLocatorRoute
  '/(auth)/auth': typeof authAuthRoute
  '/(auth)/csp-locator-map': typeof authCspLocatorMapRoute
  '/(auth)/register': typeof authRegisterRouteWithChildren
  '/dashboard/account-settings': typeof DashboardAccountSettingsRouteWithChildren
  '/dashboard/add-field': typeof DashboardAddFieldRoute
  '/dashboard/enrollment': typeof DashboardEnrollmentRouteWithChildren
  '/dashboard/fields': typeof DashboardFieldsRouteWithChildren
  '/dashboard/home': typeof DashboardHomeRouteWithChildren
  '/dashboard/network': typeof DashboardNetworkRouteWithChildren
  '/ntimev1/$': typeof Ntimev1SplatRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/(auth)/auth-redirect/$platform': typeof authAuthRedirectPlatformRoute
  '/(auth)/register/$cspSlug': typeof authRegisterCspSlugRoute
  '/(auth)/register/select-csp': typeof authRegisterSelectCspRoute
  '/dashboard/account-settings/account': typeof DashboardAccountSettingsAccountRoute
  '/dashboard/account-settings/connections': typeof DashboardAccountSettingsConnectionsRoute
  '/dashboard/account-settings/notifications': typeof DashboardAccountSettingsNotificationsRoute
  '/dashboard/account-settings/products': typeof DashboardAccountSettingsProductsRoute
  '/dashboard/all-n/$': typeof DashboardAllNSplatRoute
  '/dashboard/enrollment/contracts': typeof DashboardEnrollmentContractsRoute
  '/dashboard/enrollment/fields': typeof DashboardEnrollmentFieldsRoute
  '/dashboard/fields/$fieldId': typeof DashboardFieldsFieldIdRouteWithChildren
  '/dashboard/fields/add': typeof DashboardFieldsAddRouteWithChildren
  '/dashboard/fields/add-bulk': typeof DashboardFieldsAddBulkRoute
  '/dashboard/home/bulk-rx': typeof DashboardHomeBulkRxRoute
  '/dashboard/home/dashboard': typeof DashboardHomeDashboardRoute
  '/dashboard/home/field-config': typeof DashboardHomeFieldConfigRoute
  '/dashboard/home/imagery-qaqc': typeof DashboardHomeImageryQaqcRoute
  '/dashboard/home/insights': typeof DashboardHomeInsightsRoute
  '/dashboard/home/synced-operations': typeof DashboardHomeSyncedOperationsRoute
  '/dashboard/network/$': typeof DashboardNetworkSplatRoute
  '/dashboard/network/organizations': typeof DashboardNetworkOrganizationsRouteWithChildren
  '/dashboard/network/users': typeof DashboardNetworkUsersRouteWithChildren
  '/(auth)/register/': typeof authRegisterIndexRoute
  '/dashboard/account-settings/': typeof DashboardAccountSettingsIndexRoute
  '/dashboard/documentation/': typeof DashboardDocumentationIndexRoute
  '/dashboard/enrollment/': typeof DashboardEnrollmentIndexRoute
  '/dashboard/fields/': typeof DashboardFieldsIndexRoute
  '/dashboard/home/': typeof DashboardHomeIndexRoute
  '/dashboard/network/': typeof DashboardNetworkIndexRoute
  '/(auth)/register/partner/$': typeof authRegisterPartnerSplatRoute
  '/dashboard/field/$fieldId/$': typeof DashboardFieldFieldIdSplatRoute
  '/dashboard/fields/$fieldId/insights': typeof DashboardFieldsFieldIdInsightsRouteWithChildren
  '/dashboard/fields/$fieldId/operations': typeof DashboardFieldsFieldIdOperationsRouteWithChildren
  '/dashboard/fields/$fieldId/rx': typeof DashboardFieldsFieldIdRxRouteWithChildren
  '/dashboard/fields/$fieldId/setup': typeof DashboardFieldsFieldIdSetupRouteWithChildren
  '/dashboard/fields/add/draw': typeof DashboardFieldsAddDrawRoute
  '/dashboard/fields/add/import': typeof DashboardFieldsAddImportRoute
  '/dashboard/network/organizations/$organizationId': typeof DashboardNetworkOrganizationsOrganizationIdRoute
  '/dashboard/network/organizations/new': typeof DashboardNetworkOrganizationsNewRoute
  '/dashboard/network/users/$userId': typeof DashboardNetworkUsersUserIdRoute
  '/dashboard/network/users/new': typeof DashboardNetworkUsersNewRoute
  '/(auth)/password/reset/': typeof authPasswordResetIndexRoute
  '/dashboard/fields/$fieldId/insights/development': typeof DashboardFieldsFieldIdInsightsDevelopmentRoute
  '/dashboard/fields/$fieldId/insights/hydroflow': typeof DashboardFieldsFieldIdInsightsHydroflowRouteWithChildren
  '/dashboard/fields/$fieldId/insights/ntime': typeof DashboardFieldsFieldIdInsightsNtimeRoute
  '/dashboard/fields/$fieldId/insights/samples': typeof DashboardFieldsFieldIdInsightsSamplesRoute
  '/dashboard/fields/$fieldId/insights/settings': typeof DashboardFieldsFieldIdInsightsSettingsRoute
  '/dashboard/fields/$fieldId/insights/weather': typeof DashboardFieldsFieldIdInsightsWeatherRoute
  '/dashboard/fields/$fieldId/operations/add': typeof DashboardFieldsFieldIdOperationsAddRoute
  '/dashboard/fields/$fieldId/rx/$rxId': typeof DashboardFieldsFieldIdRxRxIdRouteWithChildren
  '/dashboard/fields/$fieldId/rx/new': typeof DashboardFieldsFieldIdRxNewRoute
  '/dashboard/fields/$fieldId/setup/chemigation-systems': typeof DashboardFieldsFieldIdSetupChemigationSystemsRoute
  '/dashboard/fields/$fieldId/setup/fertilizer-preferences': typeof DashboardFieldsFieldIdSetupFertilizerPreferencesRoute
  '/dashboard/fields/$fieldId/setup/field': typeof DashboardFieldsFieldIdSetupFieldRoute
  '/dashboard/fields/$fieldId/setup/irrigation-system': typeof DashboardFieldsFieldIdSetupIrrigationSystemRoute
  '/dashboard/fields/$fieldId/setup/management-zones': typeof DashboardFieldsFieldIdSetupManagementZonesRoute
  '/dashboard/fields/$fieldId/setup/soil-management': typeof DashboardFieldsFieldIdSetupSoilManagementRoute
  '/dashboard/fields/$fieldId/setup/treatment-sectors': typeof DashboardFieldsFieldIdSetupTreatmentSectorsRoute
  '/(auth)/password/reset/confirm/': typeof authPasswordResetConfirmIndexRoute
  '/dashboard/fields/$fieldId/operations/': typeof DashboardFieldsFieldIdOperationsIndexRoute
  '/dashboard/fields/$fieldId/rx/': typeof DashboardFieldsFieldIdRxIndexRoute
  '/dashboard/fields/$fieldId/setup/': typeof DashboardFieldsFieldIdSetupIndexRoute
  '/dashboard/fields/$fieldId/insights/hydroflow/settings': typeof DashboardFieldsFieldIdInsightsHydroflowSettingsRoute
  '/dashboard/fields/$fieldId/operations/application/$applicationOperationId': typeof DashboardFieldsFieldIdOperationsApplicationApplicationOperationIdRoute
  '/dashboard/fields/$fieldId/operations/harvest/$harvestOperationId': typeof DashboardFieldsFieldIdOperationsHarvestHarvestOperationIdRoute
  '/dashboard/fields/$fieldId/operations/irrigation/$irrigationOperationId': typeof DashboardFieldsFieldIdOperationsIrrigationIrrigationOperationIdRoute
  '/dashboard/fields/$fieldId/operations/planting/$plantingOperationId': typeof DashboardFieldsFieldIdOperationsPlantingPlantingOperationIdRoute
  '/dashboard/fields/$fieldId/insights/hydroflow/': typeof DashboardFieldsFieldIdInsightsHydroflowIndexRoute
  '/dashboard/fields/$fieldId/rx/$rxId/': typeof DashboardFieldsFieldIdRxRxIdIndexRoute
  '/dashboard/fields/$fieldId/rx/$rxId/plots/$pairId': typeof DashboardFieldsFieldIdRxRxIdPlotsPairIdRoute
  '/dashboard/fields/$fieldId/rx/$rxId/plots/draw': typeof DashboardFieldsFieldIdRxRxIdPlotsDrawRoute
  '/dashboard/fields/$fieldId/rx/$rxId/plots/place': typeof DashboardFieldsFieldIdRxRxIdPlotsPlaceRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/public-csp-locator'
    | '/auth'
    | '/csp-locator-map'
    | '/register'
    | '/dashboard/account-settings'
    | '/dashboard/add-field'
    | '/dashboard/enrollment'
    | '/dashboard/fields'
    | '/dashboard/home'
    | '/dashboard/network'
    | '/ntimev1/$'
    | '/dashboard/'
    | '/auth-redirect/$platform'
    | '/register/$cspSlug'
    | '/register/select-csp'
    | '/dashboard/account-settings/account'
    | '/dashboard/account-settings/connections'
    | '/dashboard/account-settings/notifications'
    | '/dashboard/account-settings/products'
    | '/dashboard/all-n/$'
    | '/dashboard/enrollment/contracts'
    | '/dashboard/enrollment/fields'
    | '/dashboard/fields/$fieldId'
    | '/dashboard/fields/add'
    | '/dashboard/fields/add-bulk'
    | '/dashboard/home/bulk-rx'
    | '/dashboard/home/dashboard'
    | '/dashboard/home/field-config'
    | '/dashboard/home/imagery-qaqc'
    | '/dashboard/home/insights'
    | '/dashboard/home/synced-operations'
    | '/dashboard/network/$'
    | '/dashboard/network/organizations'
    | '/dashboard/network/users'
    | '/register/'
    | '/dashboard/account-settings/'
    | '/dashboard/documentation'
    | '/dashboard/enrollment/'
    | '/dashboard/fields/'
    | '/dashboard/home/'
    | '/dashboard/network/'
    | '/register/partner/$'
    | '/dashboard/field/$fieldId/$'
    | '/dashboard/fields/$fieldId/insights'
    | '/dashboard/fields/$fieldId/operations'
    | '/dashboard/fields/$fieldId/rx'
    | '/dashboard/fields/$fieldId/setup'
    | '/dashboard/fields/add/draw'
    | '/dashboard/fields/add/import'
    | '/dashboard/network/organizations/$organizationId'
    | '/dashboard/network/organizations/new'
    | '/dashboard/network/users/$userId'
    | '/dashboard/network/users/new'
    | '/password/reset'
    | '/dashboard/fields/$fieldId/insights/development'
    | '/dashboard/fields/$fieldId/insights/hydroflow'
    | '/dashboard/fields/$fieldId/insights/ntime'
    | '/dashboard/fields/$fieldId/insights/samples'
    | '/dashboard/fields/$fieldId/insights/settings'
    | '/dashboard/fields/$fieldId/insights/weather'
    | '/dashboard/fields/$fieldId/operations/add'
    | '/dashboard/fields/$fieldId/rx/$rxId'
    | '/dashboard/fields/$fieldId/rx/new'
    | '/dashboard/fields/$fieldId/setup/chemigation-systems'
    | '/dashboard/fields/$fieldId/setup/fertilizer-preferences'
    | '/dashboard/fields/$fieldId/setup/field'
    | '/dashboard/fields/$fieldId/setup/irrigation-system'
    | '/dashboard/fields/$fieldId/setup/management-zones'
    | '/dashboard/fields/$fieldId/setup/soil-management'
    | '/dashboard/fields/$fieldId/setup/treatment-sectors'
    | '/password/reset/confirm'
    | '/dashboard/fields/$fieldId/operations/'
    | '/dashboard/fields/$fieldId/rx/'
    | '/dashboard/fields/$fieldId/setup/'
    | '/dashboard/fields/$fieldId/insights/hydroflow/settings'
    | '/dashboard/fields/$fieldId/operations/application/$applicationOperationId'
    | '/dashboard/fields/$fieldId/operations/harvest/$harvestOperationId'
    | '/dashboard/fields/$fieldId/operations/irrigation/$irrigationOperationId'
    | '/dashboard/fields/$fieldId/operations/planting/$plantingOperationId'
    | '/dashboard/fields/$fieldId/insights/hydroflow/'
    | '/dashboard/fields/$fieldId/rx/$rxId/'
    | '/dashboard/fields/$fieldId/rx/$rxId/plots/$pairId'
    | '/dashboard/fields/$fieldId/rx/$rxId/plots/draw'
    | '/dashboard/fields/$fieldId/rx/$rxId/plots/place'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/public-csp-locator'
    | '/auth'
    | '/csp-locator-map'
    | '/dashboard/add-field'
    | '/ntimev1/$'
    | '/dashboard'
    | '/auth-redirect/$platform'
    | '/register/$cspSlug'
    | '/register/select-csp'
    | '/dashboard/account-settings/account'
    | '/dashboard/account-settings/connections'
    | '/dashboard/account-settings/notifications'
    | '/dashboard/account-settings/products'
    | '/dashboard/all-n/$'
    | '/dashboard/enrollment/contracts'
    | '/dashboard/enrollment/fields'
    | '/dashboard/fields/$fieldId'
    | '/dashboard/fields/add'
    | '/dashboard/fields/add-bulk'
    | '/dashboard/home/bulk-rx'
    | '/dashboard/home/dashboard'
    | '/dashboard/home/field-config'
    | '/dashboard/home/imagery-qaqc'
    | '/dashboard/home/insights'
    | '/dashboard/home/synced-operations'
    | '/dashboard/network/$'
    | '/dashboard/network/organizations'
    | '/dashboard/network/users'
    | '/register'
    | '/dashboard/account-settings'
    | '/dashboard/documentation'
    | '/dashboard/enrollment'
    | '/dashboard/fields'
    | '/dashboard/home'
    | '/dashboard/network'
    | '/register/partner/$'
    | '/dashboard/field/$fieldId/$'
    | '/dashboard/fields/$fieldId/insights'
    | '/dashboard/fields/add/draw'
    | '/dashboard/fields/add/import'
    | '/dashboard/network/organizations/$organizationId'
    | '/dashboard/network/organizations/new'
    | '/dashboard/network/users/$userId'
    | '/dashboard/network/users/new'
    | '/password/reset'
    | '/dashboard/fields/$fieldId/insights/development'
    | '/dashboard/fields/$fieldId/insights/ntime'
    | '/dashboard/fields/$fieldId/insights/samples'
    | '/dashboard/fields/$fieldId/insights/settings'
    | '/dashboard/fields/$fieldId/insights/weather'
    | '/dashboard/fields/$fieldId/operations/add'
    | '/dashboard/fields/$fieldId/rx/new'
    | '/dashboard/fields/$fieldId/setup/chemigation-systems'
    | '/dashboard/fields/$fieldId/setup/fertilizer-preferences'
    | '/dashboard/fields/$fieldId/setup/field'
    | '/dashboard/fields/$fieldId/setup/irrigation-system'
    | '/dashboard/fields/$fieldId/setup/management-zones'
    | '/dashboard/fields/$fieldId/setup/soil-management'
    | '/dashboard/fields/$fieldId/setup/treatment-sectors'
    | '/password/reset/confirm'
    | '/dashboard/fields/$fieldId/operations'
    | '/dashboard/fields/$fieldId/rx'
    | '/dashboard/fields/$fieldId/setup'
    | '/dashboard/fields/$fieldId/insights/hydroflow/settings'
    | '/dashboard/fields/$fieldId/operations/application/$applicationOperationId'
    | '/dashboard/fields/$fieldId/operations/harvest/$harvestOperationId'
    | '/dashboard/fields/$fieldId/operations/irrigation/$irrigationOperationId'
    | '/dashboard/fields/$fieldId/operations/planting/$plantingOperationId'
    | '/dashboard/fields/$fieldId/insights/hydroflow'
    | '/dashboard/fields/$fieldId/rx/$rxId'
    | '/dashboard/fields/$fieldId/rx/$rxId/plots/$pairId'
    | '/dashboard/fields/$fieldId/rx/$rxId/plots/draw'
    | '/dashboard/fields/$fieldId/rx/$rxId/plots/place'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/public-csp-locator'
    | '/(auth)/auth'
    | '/(auth)/csp-locator-map'
    | '/(auth)/register'
    | '/dashboard/account-settings'
    | '/dashboard/add-field'
    | '/dashboard/enrollment'
    | '/dashboard/fields'
    | '/dashboard/home'
    | '/dashboard/network'
    | '/ntimev1/$'
    | '/dashboard/'
    | '/(auth)/auth-redirect/$platform'
    | '/(auth)/register/$cspSlug'
    | '/(auth)/register/select-csp'
    | '/dashboard/account-settings/account'
    | '/dashboard/account-settings/connections'
    | '/dashboard/account-settings/notifications'
    | '/dashboard/account-settings/products'
    | '/dashboard/all-n/$'
    | '/dashboard/enrollment/contracts'
    | '/dashboard/enrollment/fields'
    | '/dashboard/fields/$fieldId'
    | '/dashboard/fields/add'
    | '/dashboard/fields/add-bulk'
    | '/dashboard/home/bulk-rx'
    | '/dashboard/home/dashboard'
    | '/dashboard/home/field-config'
    | '/dashboard/home/imagery-qaqc'
    | '/dashboard/home/insights'
    | '/dashboard/home/synced-operations'
    | '/dashboard/network/$'
    | '/dashboard/network/organizations'
    | '/dashboard/network/users'
    | '/(auth)/register/'
    | '/dashboard/account-settings/'
    | '/dashboard/documentation/'
    | '/dashboard/enrollment/'
    | '/dashboard/fields/'
    | '/dashboard/home/'
    | '/dashboard/network/'
    | '/(auth)/register/partner/$'
    | '/dashboard/field/$fieldId/$'
    | '/dashboard/fields/$fieldId/insights'
    | '/dashboard/fields/$fieldId/operations'
    | '/dashboard/fields/$fieldId/rx'
    | '/dashboard/fields/$fieldId/setup'
    | '/dashboard/fields/add/draw'
    | '/dashboard/fields/add/import'
    | '/dashboard/network/organizations/$organizationId'
    | '/dashboard/network/organizations/new'
    | '/dashboard/network/users/$userId'
    | '/dashboard/network/users/new'
    | '/(auth)/password/reset/'
    | '/dashboard/fields/$fieldId/insights/development'
    | '/dashboard/fields/$fieldId/insights/hydroflow'
    | '/dashboard/fields/$fieldId/insights/ntime'
    | '/dashboard/fields/$fieldId/insights/samples'
    | '/dashboard/fields/$fieldId/insights/settings'
    | '/dashboard/fields/$fieldId/insights/weather'
    | '/dashboard/fields/$fieldId/operations/add'
    | '/dashboard/fields/$fieldId/rx/$rxId'
    | '/dashboard/fields/$fieldId/rx/new'
    | '/dashboard/fields/$fieldId/setup/chemigation-systems'
    | '/dashboard/fields/$fieldId/setup/fertilizer-preferences'
    | '/dashboard/fields/$fieldId/setup/field'
    | '/dashboard/fields/$fieldId/setup/irrigation-system'
    | '/dashboard/fields/$fieldId/setup/management-zones'
    | '/dashboard/fields/$fieldId/setup/soil-management'
    | '/dashboard/fields/$fieldId/setup/treatment-sectors'
    | '/(auth)/password/reset/confirm/'
    | '/dashboard/fields/$fieldId/operations/'
    | '/dashboard/fields/$fieldId/rx/'
    | '/dashboard/fields/$fieldId/setup/'
    | '/dashboard/fields/$fieldId/insights/hydroflow/settings'
    | '/dashboard/fields/$fieldId/operations/application/$applicationOperationId'
    | '/dashboard/fields/$fieldId/operations/harvest/$harvestOperationId'
    | '/dashboard/fields/$fieldId/operations/irrigation/$irrigationOperationId'
    | '/dashboard/fields/$fieldId/operations/planting/$plantingOperationId'
    | '/dashboard/fields/$fieldId/insights/hydroflow/'
    | '/dashboard/fields/$fieldId/rx/$rxId/'
    | '/dashboard/fields/$fieldId/rx/$rxId/plots/$pairId'
    | '/dashboard/fields/$fieldId/rx/$rxId/plots/draw'
    | '/dashboard/fields/$fieldId/rx/$rxId/plots/place'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  PublicCspLocatorRoute: typeof PublicCspLocatorRoute
  authAuthRoute: typeof authAuthRoute
  authCspLocatorMapRoute: typeof authCspLocatorMapRoute
  authRegisterRoute: typeof authRegisterRouteWithChildren
  Ntimev1SplatRoute: typeof Ntimev1SplatRoute
  authAuthRedirectPlatformRoute: typeof authAuthRedirectPlatformRoute
  authPasswordResetIndexRoute: typeof authPasswordResetIndexRoute
  authPasswordResetConfirmIndexRoute: typeof authPasswordResetConfirmIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  PublicCspLocatorRoute: PublicCspLocatorRoute,
  authAuthRoute: authAuthRoute,
  authCspLocatorMapRoute: authCspLocatorMapRoute,
  authRegisterRoute: authRegisterRouteWithChildren,
  Ntimev1SplatRoute: Ntimev1SplatRoute,
  authAuthRedirectPlatformRoute: authAuthRedirectPlatformRoute,
  authPasswordResetIndexRoute: authPasswordResetIndexRoute,
  authPasswordResetConfirmIndexRoute: authPasswordResetConfirmIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/dashboard",
        "/public-csp-locator",
        "/(auth)/auth",
        "/(auth)/csp-locator-map",
        "/(auth)/register",
        "/ntimev1/$",
        "/(auth)/auth-redirect/$platform",
        "/(auth)/password/reset/",
        "/(auth)/password/reset/confirm/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/dashboard": {
      "filePath": "dashboard.tsx",
      "children": [
        "/dashboard/account-settings",
        "/dashboard/add-field",
        "/dashboard/enrollment",
        "/dashboard/fields",
        "/dashboard/home",
        "/dashboard/network",
        "/dashboard/",
        "/dashboard/all-n/$",
        "/dashboard/documentation/",
        "/dashboard/field/$fieldId/$"
      ]
    },
    "/public-csp-locator": {
      "filePath": "public-csp-locator.tsx"
    },
    "/(auth)/auth": {
      "filePath": "(auth)/auth.tsx"
    },
    "/(auth)/csp-locator-map": {
      "filePath": "(auth)/csp-locator-map.tsx"
    },
    "/(auth)/register": {
      "filePath": "(auth)/register.tsx",
      "children": [
        "/(auth)/register/$cspSlug",
        "/(auth)/register/select-csp",
        "/(auth)/register/",
        "/(auth)/register/partner/$"
      ]
    },
    "/dashboard/account-settings": {
      "filePath": "dashboard/account-settings.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/account-settings/account",
        "/dashboard/account-settings/connections",
        "/dashboard/account-settings/notifications",
        "/dashboard/account-settings/products",
        "/dashboard/account-settings/"
      ]
    },
    "/dashboard/add-field": {
      "filePath": "dashboard/add-field.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/enrollment": {
      "filePath": "dashboard/enrollment.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/enrollment/contracts",
        "/dashboard/enrollment/fields",
        "/dashboard/enrollment/"
      ]
    },
    "/dashboard/fields": {
      "filePath": "dashboard/fields.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/fields/$fieldId",
        "/dashboard/fields/add",
        "/dashboard/fields/add-bulk",
        "/dashboard/fields/"
      ]
    },
    "/dashboard/home": {
      "filePath": "dashboard/home.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/home/bulk-rx",
        "/dashboard/home/dashboard",
        "/dashboard/home/field-config",
        "/dashboard/home/imagery-qaqc",
        "/dashboard/home/insights",
        "/dashboard/home/synced-operations",
        "/dashboard/home/"
      ]
    },
    "/dashboard/network": {
      "filePath": "dashboard/network.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/network/$",
        "/dashboard/network/organizations",
        "/dashboard/network/users",
        "/dashboard/network/"
      ]
    },
    "/ntimev1/$": {
      "filePath": "ntimev1.$.tsx"
    },
    "/dashboard/": {
      "filePath": "dashboard/index.tsx",
      "parent": "/dashboard"
    },
    "/(auth)/auth-redirect/$platform": {
      "filePath": "(auth)/auth-redirect.$platform.tsx"
    },
    "/(auth)/register/$cspSlug": {
      "filePath": "(auth)/register.$cspSlug.tsx",
      "parent": "/(auth)/register"
    },
    "/(auth)/register/select-csp": {
      "filePath": "(auth)/register.select-csp.tsx",
      "parent": "/(auth)/register"
    },
    "/dashboard/account-settings/account": {
      "filePath": "dashboard/account-settings/account.tsx",
      "parent": "/dashboard/account-settings"
    },
    "/dashboard/account-settings/connections": {
      "filePath": "dashboard/account-settings/connections.tsx",
      "parent": "/dashboard/account-settings"
    },
    "/dashboard/account-settings/notifications": {
      "filePath": "dashboard/account-settings/notifications.tsx",
      "parent": "/dashboard/account-settings"
    },
    "/dashboard/account-settings/products": {
      "filePath": "dashboard/account-settings/products.tsx",
      "parent": "/dashboard/account-settings"
    },
    "/dashboard/all-n/$": {
      "filePath": "dashboard/all-n/$.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/enrollment/contracts": {
      "filePath": "dashboard/enrollment/contracts.tsx",
      "parent": "/dashboard/enrollment"
    },
    "/dashboard/enrollment/fields": {
      "filePath": "dashboard/enrollment/fields.tsx",
      "parent": "/dashboard/enrollment"
    },
    "/dashboard/fields/$fieldId": {
      "filePath": "dashboard/fields/$fieldId.tsx",
      "parent": "/dashboard/fields",
      "children": [
        "/dashboard/fields/$fieldId/insights",
        "/dashboard/fields/$fieldId/operations",
        "/dashboard/fields/$fieldId/rx",
        "/dashboard/fields/$fieldId/setup"
      ]
    },
    "/dashboard/fields/add": {
      "filePath": "dashboard/fields/add.tsx",
      "parent": "/dashboard/fields",
      "children": [
        "/dashboard/fields/add/draw",
        "/dashboard/fields/add/import"
      ]
    },
    "/dashboard/fields/add-bulk": {
      "filePath": "dashboard/fields/add-bulk.tsx",
      "parent": "/dashboard/fields"
    },
    "/dashboard/home/bulk-rx": {
      "filePath": "dashboard/home/bulk-rx.tsx",
      "parent": "/dashboard/home"
    },
    "/dashboard/home/dashboard": {
      "filePath": "dashboard/home/dashboard.tsx",
      "parent": "/dashboard/home"
    },
    "/dashboard/home/field-config": {
      "filePath": "dashboard/home/field-config.tsx",
      "parent": "/dashboard/home"
    },
    "/dashboard/home/imagery-qaqc": {
      "filePath": "dashboard/home/imagery-qaqc.tsx",
      "parent": "/dashboard/home"
    },
    "/dashboard/home/insights": {
      "filePath": "dashboard/home/insights.tsx",
      "parent": "/dashboard/home"
    },
    "/dashboard/home/synced-operations": {
      "filePath": "dashboard/home/synced-operations.tsx",
      "parent": "/dashboard/home"
    },
    "/dashboard/network/$": {
      "filePath": "dashboard/network/$.tsx",
      "parent": "/dashboard/network"
    },
    "/dashboard/network/organizations": {
      "filePath": "dashboard/network/organizations.tsx",
      "parent": "/dashboard/network",
      "children": [
        "/dashboard/network/organizations/$organizationId",
        "/dashboard/network/organizations/new"
      ]
    },
    "/dashboard/network/users": {
      "filePath": "dashboard/network/users.tsx",
      "parent": "/dashboard/network",
      "children": [
        "/dashboard/network/users/$userId",
        "/dashboard/network/users/new"
      ]
    },
    "/(auth)/register/": {
      "filePath": "(auth)/register.index.tsx",
      "parent": "/(auth)/register"
    },
    "/dashboard/account-settings/": {
      "filePath": "dashboard/account-settings/index.tsx",
      "parent": "/dashboard/account-settings"
    },
    "/dashboard/documentation/": {
      "filePath": "dashboard/documentation/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/enrollment/": {
      "filePath": "dashboard/enrollment/index.tsx",
      "parent": "/dashboard/enrollment"
    },
    "/dashboard/fields/": {
      "filePath": "dashboard/fields/index.tsx",
      "parent": "/dashboard/fields"
    },
    "/dashboard/home/": {
      "filePath": "dashboard/home/index.tsx",
      "parent": "/dashboard/home"
    },
    "/dashboard/network/": {
      "filePath": "dashboard/network/index.tsx",
      "parent": "/dashboard/network"
    },
    "/(auth)/register/partner/$": {
      "filePath": "(auth)/register.partner.$.tsx",
      "parent": "/(auth)/register"
    },
    "/dashboard/field/$fieldId/$": {
      "filePath": "dashboard/field/$fieldId.$.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/fields/$fieldId/insights": {
      "filePath": "dashboard/fields/$fieldId/insights.tsx",
      "parent": "/dashboard/fields/$fieldId",
      "children": [
        "/dashboard/fields/$fieldId/insights/development",
        "/dashboard/fields/$fieldId/insights/hydroflow",
        "/dashboard/fields/$fieldId/insights/ntime",
        "/dashboard/fields/$fieldId/insights/samples",
        "/dashboard/fields/$fieldId/insights/settings",
        "/dashboard/fields/$fieldId/insights/weather"
      ]
    },
    "/dashboard/fields/$fieldId/operations": {
      "filePath": "dashboard/fields/$fieldId/operations.tsx",
      "parent": "/dashboard/fields/$fieldId",
      "children": [
        "/dashboard/fields/$fieldId/operations/add",
        "/dashboard/fields/$fieldId/operations/",
        "/dashboard/fields/$fieldId/operations/application/$applicationOperationId",
        "/dashboard/fields/$fieldId/operations/harvest/$harvestOperationId",
        "/dashboard/fields/$fieldId/operations/irrigation/$irrigationOperationId",
        "/dashboard/fields/$fieldId/operations/planting/$plantingOperationId"
      ]
    },
    "/dashboard/fields/$fieldId/rx": {
      "filePath": "dashboard/fields/$fieldId/rx.tsx",
      "parent": "/dashboard/fields/$fieldId",
      "children": [
        "/dashboard/fields/$fieldId/rx/$rxId",
        "/dashboard/fields/$fieldId/rx/new",
        "/dashboard/fields/$fieldId/rx/"
      ]
    },
    "/dashboard/fields/$fieldId/setup": {
      "filePath": "dashboard/fields/$fieldId/setup.tsx",
      "parent": "/dashboard/fields/$fieldId",
      "children": [
        "/dashboard/fields/$fieldId/setup/chemigation-systems",
        "/dashboard/fields/$fieldId/setup/fertilizer-preferences",
        "/dashboard/fields/$fieldId/setup/field",
        "/dashboard/fields/$fieldId/setup/irrigation-system",
        "/dashboard/fields/$fieldId/setup/management-zones",
        "/dashboard/fields/$fieldId/setup/soil-management",
        "/dashboard/fields/$fieldId/setup/treatment-sectors",
        "/dashboard/fields/$fieldId/setup/"
      ]
    },
    "/dashboard/fields/add/draw": {
      "filePath": "dashboard/fields/add/draw.tsx",
      "parent": "/dashboard/fields/add"
    },
    "/dashboard/fields/add/import": {
      "filePath": "dashboard/fields/add/import.tsx",
      "parent": "/dashboard/fields/add"
    },
    "/dashboard/network/organizations/$organizationId": {
      "filePath": "dashboard/network/organizations/$organizationId.tsx",
      "parent": "/dashboard/network/organizations"
    },
    "/dashboard/network/organizations/new": {
      "filePath": "dashboard/network/organizations/new.tsx",
      "parent": "/dashboard/network/organizations"
    },
    "/dashboard/network/users/$userId": {
      "filePath": "dashboard/network/users/$userId.tsx",
      "parent": "/dashboard/network/users"
    },
    "/dashboard/network/users/new": {
      "filePath": "dashboard/network/users/new.tsx",
      "parent": "/dashboard/network/users"
    },
    "/(auth)/password/reset/": {
      "filePath": "(auth)/password/reset.index.tsx"
    },
    "/dashboard/fields/$fieldId/insights/development": {
      "filePath": "dashboard/fields/$fieldId/insights.development.tsx",
      "parent": "/dashboard/fields/$fieldId/insights"
    },
    "/dashboard/fields/$fieldId/insights/hydroflow": {
      "filePath": "dashboard/fields/$fieldId/insights.hydroflow.tsx",
      "parent": "/dashboard/fields/$fieldId/insights",
      "children": [
        "/dashboard/fields/$fieldId/insights/hydroflow/settings",
        "/dashboard/fields/$fieldId/insights/hydroflow/"
      ]
    },
    "/dashboard/fields/$fieldId/insights/ntime": {
      "filePath": "dashboard/fields/$fieldId/insights.ntime.tsx",
      "parent": "/dashboard/fields/$fieldId/insights"
    },
    "/dashboard/fields/$fieldId/insights/samples": {
      "filePath": "dashboard/fields/$fieldId/insights.samples.tsx",
      "parent": "/dashboard/fields/$fieldId/insights"
    },
    "/dashboard/fields/$fieldId/insights/settings": {
      "filePath": "dashboard/fields/$fieldId/insights/settings.tsx",
      "parent": "/dashboard/fields/$fieldId/insights"
    },
    "/dashboard/fields/$fieldId/insights/weather": {
      "filePath": "dashboard/fields/$fieldId/insights.weather.tsx",
      "parent": "/dashboard/fields/$fieldId/insights"
    },
    "/dashboard/fields/$fieldId/operations/add": {
      "filePath": "dashboard/fields/$fieldId/operations/add.tsx",
      "parent": "/dashboard/fields/$fieldId/operations"
    },
    "/dashboard/fields/$fieldId/rx/$rxId": {
      "filePath": "dashboard/fields/$fieldId/rx/$rxId.tsx",
      "parent": "/dashboard/fields/$fieldId/rx",
      "children": [
        "/dashboard/fields/$fieldId/rx/$rxId/",
        "/dashboard/fields/$fieldId/rx/$rxId/plots/$pairId",
        "/dashboard/fields/$fieldId/rx/$rxId/plots/draw",
        "/dashboard/fields/$fieldId/rx/$rxId/plots/place"
      ]
    },
    "/dashboard/fields/$fieldId/rx/new": {
      "filePath": "dashboard/fields/$fieldId/rx/new.tsx",
      "parent": "/dashboard/fields/$fieldId/rx"
    },
    "/dashboard/fields/$fieldId/setup/chemigation-systems": {
      "filePath": "dashboard/fields/$fieldId/setup.chemigation-systems.tsx",
      "parent": "/dashboard/fields/$fieldId/setup"
    },
    "/dashboard/fields/$fieldId/setup/fertilizer-preferences": {
      "filePath": "dashboard/fields/$fieldId/setup.fertilizer-preferences.tsx",
      "parent": "/dashboard/fields/$fieldId/setup"
    },
    "/dashboard/fields/$fieldId/setup/field": {
      "filePath": "dashboard/fields/$fieldId/setup.field.tsx",
      "parent": "/dashboard/fields/$fieldId/setup"
    },
    "/dashboard/fields/$fieldId/setup/irrigation-system": {
      "filePath": "dashboard/fields/$fieldId/setup.irrigation-system.tsx",
      "parent": "/dashboard/fields/$fieldId/setup"
    },
    "/dashboard/fields/$fieldId/setup/management-zones": {
      "filePath": "dashboard/fields/$fieldId/setup.management-zones.tsx",
      "parent": "/dashboard/fields/$fieldId/setup"
    },
    "/dashboard/fields/$fieldId/setup/soil-management": {
      "filePath": "dashboard/fields/$fieldId/setup.soil-management.tsx",
      "parent": "/dashboard/fields/$fieldId/setup"
    },
    "/dashboard/fields/$fieldId/setup/treatment-sectors": {
      "filePath": "dashboard/fields/$fieldId/setup.treatment-sectors.tsx",
      "parent": "/dashboard/fields/$fieldId/setup"
    },
    "/(auth)/password/reset/confirm/": {
      "filePath": "(auth)/password/reset.confirm.index.tsx"
    },
    "/dashboard/fields/$fieldId/operations/": {
      "filePath": "dashboard/fields/$fieldId/operations/index.tsx",
      "parent": "/dashboard/fields/$fieldId/operations"
    },
    "/dashboard/fields/$fieldId/rx/": {
      "filePath": "dashboard/fields/$fieldId/rx/index.tsx",
      "parent": "/dashboard/fields/$fieldId/rx"
    },
    "/dashboard/fields/$fieldId/setup/": {
      "filePath": "dashboard/fields/$fieldId/setup/index.tsx",
      "parent": "/dashboard/fields/$fieldId/setup"
    },
    "/dashboard/fields/$fieldId/insights/hydroflow/settings": {
      "filePath": "dashboard/fields/$fieldId/insights.hydroflow.settings.tsx",
      "parent": "/dashboard/fields/$fieldId/insights/hydroflow"
    },
    "/dashboard/fields/$fieldId/operations/application/$applicationOperationId": {
      "filePath": "dashboard/fields/$fieldId/operations/application.$applicationOperationId.tsx",
      "parent": "/dashboard/fields/$fieldId/operations"
    },
    "/dashboard/fields/$fieldId/operations/harvest/$harvestOperationId": {
      "filePath": "dashboard/fields/$fieldId/operations/harvest.$harvestOperationId.tsx",
      "parent": "/dashboard/fields/$fieldId/operations"
    },
    "/dashboard/fields/$fieldId/operations/irrigation/$irrigationOperationId": {
      "filePath": "dashboard/fields/$fieldId/operations/irrigation.$irrigationOperationId.tsx",
      "parent": "/dashboard/fields/$fieldId/operations"
    },
    "/dashboard/fields/$fieldId/operations/planting/$plantingOperationId": {
      "filePath": "dashboard/fields/$fieldId/operations/planting.$plantingOperationId.tsx",
      "parent": "/dashboard/fields/$fieldId/operations"
    },
    "/dashboard/fields/$fieldId/insights/hydroflow/": {
      "filePath": "dashboard/fields/$fieldId/insights.hydroflow.index.tsx",
      "parent": "/dashboard/fields/$fieldId/insights/hydroflow"
    },
    "/dashboard/fields/$fieldId/rx/$rxId/": {
      "filePath": "dashboard/fields/$fieldId/rx/$rxId/index.tsx",
      "parent": "/dashboard/fields/$fieldId/rx/$rxId"
    },
    "/dashboard/fields/$fieldId/rx/$rxId/plots/$pairId": {
      "filePath": "dashboard/fields/$fieldId/rx/$rxId/plots/$pairId.tsx",
      "parent": "/dashboard/fields/$fieldId/rx/$rxId"
    },
    "/dashboard/fields/$fieldId/rx/$rxId/plots/draw": {
      "filePath": "dashboard/fields/$fieldId/rx/$rxId/plots/draw.tsx",
      "parent": "/dashboard/fields/$fieldId/rx/$rxId"
    },
    "/dashboard/fields/$fieldId/rx/$rxId/plots/place": {
      "filePath": "dashboard/fields/$fieldId/rx/$rxId/plots/place.tsx",
      "parent": "/dashboard/fields/$fieldId/rx/$rxId"
    }
  }
}
ROUTE_MANIFEST_END */
